var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _g, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _g2, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _g3, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _g4, _g5, _g6, _path357, _path358, _path359, _path360, _path361, _g7, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _g8, _path386, _path387, _path388, _path389, _path390, _path391;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaterialMovements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 140,
    height: 85.718,
    viewBox: "0 0 140 85.718",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26801",
    "data-name": "Rectangle 26801",
    width: 140,
    height: 85.718,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26792",
    "data-name": "Rectangle 26792",
    width: 3.917,
    height: 8.388,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26793",
    "data-name": "Rectangle 26793",
    width: 13.483,
    height: 4.585,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26794",
    "data-name": "Rectangle 26794",
    width: 32.06,
    height: 16.339,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26795",
    "data-name": "Rectangle 26795",
    width: 6.352,
    height: 18.044,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26796",
    "data-name": "Rectangle 26796",
    width: 22.456,
    height: 27.364,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26797",
    "data-name": "Rectangle 26797",
    width: 9.246,
    height: 5.509,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26798",
    "data-name": "Rectangle 26798",
    width: 34.565,
    height: 12.204,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26799",
    "data-name": "Rectangle 26799",
    width: 4.738,
    height: 1.451,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Material_Movements",
    "data-name": "Material Movements",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72796",
    "data-name": "Group 72796",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72795",
    "data-name": "Group 72795",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72794",
    "data-name": "Group 72794",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_78524",
    "data-name": "Path 78524",
    d: "M94.36,41.763,49.379,15.793c-1.877-1.083-3.571-1.271-4.778-.7v0l-.025.015a2.9,2.9,0,0,0-.369.212l-8.063,4.649.862.811,2.922,3.3c.158,3.663,4.868,3.7,8.433,5.76l40.755,23.53,2.006,7.191,8.127-4.692c.07-.037.138-.076.2-.118l.025-.014-1.02.589c.952-.615,2.544-2.368,2.544-4,0-3.715-2.972-8.443-6.639-10.56",
    transform: "translate(-9.126 -3.732)",
    fill: "#4f1f26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78525",
    "data-name": "Path 78525",
    d: "M45.078,17.039,51.01,15.88a9.274,9.274,0,0,0-.736-.739l-5.656,1.144-2.838,3.906.411.782Z",
    transform: "translate(-10.549 -3.823)",
    fill: "#5d3138"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78526",
    "data-name": "Path 78526",
    d: "M50.025,19.854,55.957,18.7a9.367,9.367,0,0,0-.736-.739L49.564,19.1l-2.838,3.906.412.782Z",
    transform: "translate(-11.799 -4.534)",
    fill: "#5d3138"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78527",
    "data-name": "Path 78527",
    d: "M54.971,22.669,60.9,21.51a9.4,9.4,0,0,0-.736-.739l-5.656,1.144-2.839,3.906.412.782Z",
    transform: "translate(-13.047 -5.245)",
    fill: "#5d3138"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78528",
    "data-name": "Path 78528",
    d: "M59.92,25.484l5.932-1.159a9.273,9.273,0,0,0-.736-.739L59.459,24.73l-2.838,3.906.411.782Z",
    transform: "translate(-14.297 -5.956)",
    fill: "#5d3138"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78529",
    "data-name": "Path 78529",
    d: "M64.866,28.3,70.8,27.141a9.407,9.407,0,0,0-.736-.739l-5.656,1.144-2.839,3.906.412.782Z",
    transform: "translate(-15.546 -6.667)",
    fill: "#5d3138"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78530",
    "data-name": "Path 78530",
    d: "M69.814,31.115l5.932-1.159a9.275,9.275,0,0,0-.736-.739l-5.656,1.144-2.838,3.906.411.782Z",
    transform: "translate(-16.795 -7.377)",
    fill: "#5d3138"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78531",
    "data-name": "Path 78531",
    d: "M74.762,33.93l5.932-1.159a9.276,9.276,0,0,0-.736-.739L74.3,33.176l-2.837,3.906.411.782Z",
    transform: "translate(-18.045 -8.088)",
    fill: "#5d3138"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78532",
    "data-name": "Path 78532",
    d: "M79.708,36.745l5.932-1.159a9.408,9.408,0,0,0-.736-.739l-5.656,1.144L76.409,39.9l.412.782Z",
    transform: "translate(-19.294 -8.799)",
    fill: "#5d3138"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78533",
    "data-name": "Path 78533",
    d: "M84.656,39.56,90.588,38.4a9.275,9.275,0,0,0-.736-.739L84.2,38.806l-2.838,3.906.411.782Z",
    transform: "translate(-20.543 -9.51)",
    fill: "#5d3138"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78534",
    "data-name": "Path 78534",
    d: "M89.6,42.376l5.932-1.159a9.273,9.273,0,0,0-.736-.739l-5.656,1.144L86.3,45.528l.412.782Z",
    transform: "translate(-21.792 -10.221)",
    fill: "#5d3138"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78535",
    "data-name": "Path 78535",
    d: "M94.55,45.191l5.932-1.159a9.407,9.407,0,0,0-.736-.739L94.09,44.437l-2.839,3.906.412.782Z",
    transform: "translate(-23.041 -10.932)",
    fill: "#5d3138"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78536",
    "data-name": "Path 78536",
    d: "M99.5,48.006l5.932-1.159a9.273,9.273,0,0,0-.736-.739l-5.656,1.144L96.2,51.158l.412.782Z",
    transform: "translate(-24.291 -11.642)",
    fill: "#5d3138"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78537",
    "data-name": "Path 78537",
    d: "M104.445,50.821l5.931-1.159a9.273,9.273,0,0,0-.736-.739l-5.656,1.144-2.838,3.906.411.782Z",
    transform: "translate(-25.54 -12.353)",
    fill: "#5d3138"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78538",
    "data-name": "Path 78538",
    d: "M109.325,53.713l5.932-1.159a9.272,9.272,0,0,0-.736-.739l-5.656,1.144-2.838,3.906.411.782Z",
    transform: "translate(-26.772 -13.084)",
    fill: "#5d3138"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78539",
    "data-name": "Path 78539",
    d: "M112.754,58.257l5.932-1.159a9.274,9.274,0,0,0-.736-.739L112.293,57.5l-2.838,3.906.411.782Z",
    transform: "translate(-27.638 -14.231)",
    fill: "#5d3138"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78540",
    "data-name": "Path 78540",
    d: "M114.352,63.427l5.932-1.159a9.273,9.273,0,0,0-.736-.739l-5.656,1.144-2.838,3.906.412.782Z",
    transform: "translate(-28.041 -15.536)",
    fill: "#5d3138"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78541",
    "data-name": "Path 78541",
    d: "M114.422,69.118l5.932-1.159a9.407,9.407,0,0,0-.736-.739l-5.656,1.144-2.839,3.906.412.782Z",
    transform: "translate(-28.059 -16.973)",
    fill: "#5d3138"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78542",
    "data-name": "Path 78542",
    d: "M40.746,22.064l44.981,25.97c3.667,2.117,6.64,6.845,6.64,10.56s-2.973,5.01-6.64,2.893L40.746,35.517c-3.667-2.118-6.639-6.846-6.639-10.56s2.972-5.01,6.639-2.894",
    transform: "translate(-8.612 -5.314)",
    fill: "#816065"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78543",
    "data-name": "Path 78543",
    d: "M91.469,58.4a4.3,4.3,0,0,1-.093.915c-.464,2.121-2.615,2.692-5.191,1.2L41.2,34.548c-2.913-1.682-5.283-5.369-5.283-8.219,0-2.466,1.775-3.509,4.14-2.656a7.171,7.171,0,0,1,1.142.537l44.981,25.97c2.914,1.683,5.283,5.37,5.283,8.219",
    transform: "translate(-9.07 -5.903)",
    fill: "#4f1f26"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78544",
    "data-name": "Path 78544",
    d: "M92.836,58.5a4.305,4.305,0,0,1-.093.915,7.089,7.089,0,0,1-1.142-.538L46.62,32.9c-2.914-1.681-5.283-5.369-5.283-8.219a4.3,4.3,0,0,1,.093-.914,7.171,7.171,0,0,1,1.142.537l2.319,1.34,1.075.62,4.625,2.67,6.881,3.974.03.016L59,33.8l1.076.622L63.1,36.16l4.8,2.77,6.043,3.488.7.406.149.086L77.2,44.3l1.032.6,2.506,1.446,5.407,3.121,1.408.813c.132.077.264.157.394.242a9.907,9.907,0,0,1,1.16.884c2.157,1.9,3.729,4.773,3.729,7.094",
    transform: "translate(-10.438 -6.003)",
    fill: "#380009"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78545",
    "data-name": "Path 78545",
    d: "M75.388,50.6c0,1.208-.853,1.694-1.905,1.086A4.2,4.2,0,0,1,71.577,48.4c0-1.207.854-1.694,1.906-1.086A4.2,4.2,0,0,1,75.388,50.6",
    transform: "translate(-18.073 -11.881)",
    fill: "#ba9c8c"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78546",
    "data-name": "Path 78546",
    d: "M75.282,50.262c0,1.031-.728,1.446-1.627.928a3.586,3.586,0,0,1-1.627-2.806c0-1.031.729-1.446,1.627-.928a3.585,3.585,0,0,1,1.627,2.806",
    transform: "translate(-18.187 -11.926)",
    fill: "#8c7370"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78547",
    "data-name": "Path 78547",
    d: "M47.444,31.532c0,1.568-1.108,2.2-2.475,1.411a5.455,5.455,0,0,1-2.475-4.269c0-1.568,1.109-2.2,2.475-1.411a5.453,5.453,0,0,1,2.475,4.269",
    transform: "translate(-10.73 -6.798)",
    fill: "#4f1f26"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78548",
    "data-name": "Path 78548",
    d: "M46.814,29.939l-1.236.537a4.347,4.347,0,0,1,.523,2.176c-.034,1.256-.25,1.162-.25,1.162l-1.281.443-3.194-6.17,1.7-1.038L45.042,28.1Z",
    transform: "translate(-10.447 -6.83)",
    fill: "#4f1f26"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78549",
    "data-name": "Path 78549",
    d: "M45.29,32.865c0,1.568-1.108,2.2-2.475,1.411a5.453,5.453,0,0,1-2.475-4.268c0-1.568,1.109-2.2,2.475-1.411a5.453,5.453,0,0,1,2.475,4.269",
    transform: "translate(-10.186 -7.135)",
    fill: "#ba9c8c"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78550",
    "data-name": "Path 78550",
    d: "M44.846,32.769c0,1.144-.808,1.6-1.8,1.029a3.974,3.974,0,0,1-1.8-3.112c0-1.144.807-1.6,1.8-1.029a3.974,3.974,0,0,1,1.8,3.112",
    transform: "translate(-10.413 -7.426)",
    fill: "#8c7370"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78551",
    "data-name": "Path 78551",
    d: "M87.032,53.958c0,1.568-1.108,2.2-2.475,1.411A5.455,5.455,0,0,1,82.082,51.1c0-1.568,1.109-2.2,2.475-1.411a5.453,5.453,0,0,1,2.475,4.269",
    transform: "translate(-20.726 -12.461)",
    fill: "#4f1f26"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78552",
    "data-name": "Path 78552",
    d: "M86.4,52.366l-1.236.537a4.348,4.348,0,0,1,.523,2.176c-.034,1.256-.25,1.162-.25,1.162l-1.281.443-3.194-6.17,1.7-1.038,1.966,1.049Z",
    transform: "translate(-20.443 -12.493)",
    fill: "#4f1f26"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78553",
    "data-name": "Path 78553",
    d: "M84.878,55.292c0,1.568-1.108,2.2-2.475,1.411a5.453,5.453,0,0,1-2.475-4.268c0-1.568,1.109-2.2,2.475-1.411a5.453,5.453,0,0,1,2.475,4.269",
    transform: "translate(-20.182 -12.798)",
    fill: "#ba9c8c"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78554",
    "data-name": "Path 78554",
    d: "M84.434,55.2c0,1.144-.808,1.6-1.8,1.029a3.974,3.974,0,0,1-1.8-3.112c0-1.144.807-1.6,1.8-1.029a3.974,3.974,0,0,1,1.8,3.112",
    transform: "translate(-20.409 -13.089)",
    fill: "#8c7370"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78555",
    "data-name": "Path 78555",
    d: "M69.016,43.686c0,1.568-1.108,2.2-2.475,1.411a5.455,5.455,0,0,1-2.475-4.269c0-1.568,1.109-2.2,2.475-1.411a5.453,5.453,0,0,1,2.475,4.269",
    transform: "translate(-16.177 -9.867)",
    fill: "#4f1f26"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78556",
    "data-name": "Path 78556",
    d: "M68.387,42.094l-1.236.537a4.348,4.348,0,0,1,.522,2.176c-.034,1.256-.25,1.162-.25,1.162l-1.281.443-3.194-6.17,1.7-1.038,1.966,1.049Z",
    transform: "translate(-15.895 -9.899)",
    fill: "#4f1f26"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78557",
    "data-name": "Path 78557",
    d: "M66.863,45.019c0,1.568-1.108,2.2-2.475,1.411a5.453,5.453,0,0,1-2.475-4.268c0-1.568,1.109-2.2,2.475-1.411a5.453,5.453,0,0,1,2.475,4.269",
    transform: "translate(-15.633 -10.204)",
    fill: "#ba9c8c"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78558",
    "data-name": "Path 78558",
    d: "M66.419,44.923c0,1.144-.808,1.6-1.8,1.029a3.974,3.974,0,0,1-1.8-3.112c0-1.144.808-1.6,1.8-1.029a3.975,3.975,0,0,1,1.8,3.112",
    transform: "translate(-15.86 -10.495)",
    fill: "#8c7370"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78559",
    "data-name": "Path 78559",
    d: "M87.2,50.018l-.989.912-2.295,1.208v0h0L77.172,44.4l-.306-.35,6.745,3.894,2.562,1.479Z",
    transform: "translate(-19.409 -11.123)",
    fill: "#bb5900"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78560",
    "data-name": "Path 78560",
    d: "M82.662,47.4,80.41,50.109h0l-16.6-9.587-.842-4.5,5.593,3.23,4.8,2.77L80.1,45.917Z",
    transform: "translate(-15.899 -9.096)",
    fill: "#e28b00"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78561",
    "data-name": "Path 78561",
    d: "M81.99,47.007l-.217.259-6.221-3.8-5.1-3.12,4.8,2.77Z",
    transform: "translate(-17.788 -10.187)",
    fill: "#bb5300"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78562",
    "data-name": "Path 78562",
    d: "M52.926,37.6c0,1.208-.853,1.694-1.905,1.086A4.2,4.2,0,0,1,49.115,35.4c0-1.208.854-1.694,1.906-1.086A4.2,4.2,0,0,1,52.926,37.6",
    transform: "translate(-12.402 -8.598)",
    fill: "#ba9c8c"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78563",
    "data-name": "Path 78563",
    d: "M52.82,37.26c0,1.031-.728,1.446-1.627.928a3.586,3.586,0,0,1-1.627-2.806c0-1.031.729-1.446,1.627-.928A3.585,3.585,0,0,1,52.82,37.26",
    transform: "translate(-12.516 -8.643)",
    fill: "#8c7370"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78564",
    "data-name": "Path 78564",
    d: "M59.472,41.614c0,1.208-.853,1.695-1.905,1.087a4.2,4.2,0,0,1-1.906-3.287c0-1.207.854-1.694,1.906-1.086a4.2,4.2,0,0,1,1.905,3.287",
    transform: "translate(-14.055 -9.612)",
    fill: "#ba9c8c"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78565",
    "data-name": "Path 78565",
    d: "M59.365,41.275c0,1.031-.728,1.446-1.627.928A3.586,3.586,0,0,1,56.111,39.4c0-1.031.729-1.446,1.627-.928a3.585,3.585,0,0,1,1.627,2.806",
    transform: "translate(-14.168 -9.657)",
    fill: "#8c7370"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78566",
    "data-name": "Path 78566",
    d: "M91.764,59.464c0,1.208-.853,1.694-1.905,1.087a4.2,4.2,0,0,1-1.906-3.287c0-1.207.854-1.694,1.906-1.086a4.2,4.2,0,0,1,1.905,3.287",
    transform: "translate(-22.209 -14.119)",
    fill: "#ba9c8c"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78567",
    "data-name": "Path 78567",
    d: "M91.658,59.125c0,1.031-.728,1.446-1.627.928A3.586,3.586,0,0,1,88.4,57.246c0-1.031.729-1.446,1.627-.928a3.585,3.585,0,0,1,1.627,2.806",
    transform: "translate(-22.322 -14.164)",
    fill: "#8c7370"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78568",
    "data-name": "Path 78568",
    d: "M98.311,63.479c0,1.208-.853,1.694-1.905,1.087A4.2,4.2,0,0,1,94.5,61.279c0-1.207.854-1.694,1.906-1.086a4.2,4.2,0,0,1,1.905,3.287",
    transform: "translate(-23.861 -15.133)",
    fill: "#ba9c8c"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78569",
    "data-name": "Path 78569",
    d: "M98.2,63.14c0,1.031-.728,1.446-1.627.928a3.586,3.586,0,0,1-1.627-2.806c0-1.031.729-1.446,1.627-.928A3.585,3.585,0,0,1,98.2,63.14",
    transform: "translate(-23.975 -15.178)",
    fill: "#8c7370"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78570",
    "data-name": "Path 78570",
    d: "M61.924,36.657l-.187.172-.116.107-.046.043-1.892,1.745-1.234.65v0h0l-3.626-4.158h0l-1.227-1.4L52.44,32.483l-1.627-1.866h0l-.779-.894.126-.585,2.629,1.156,6.881,3.974,1.888,2Z",
    transform: "translate(-12.633 -7.357)",
    fill: "#bb5900"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78571",
    "data-name": "Path 78571",
    d: "M61.893,36.037l-.706.539-.2-.151L58.5,34.53l-.03.035-.493.586-.134.159-.707.539-5.331-3.878-3.057-2.224-.088-.311-.316-1.118-.818-1.208,4.626,2.67,6.881,3.974.029.016,1.5.866,1.076.622Z",
    transform: "translate(-12.002 -6.846)",
    fill: "#9b7a6d"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78572",
    "data-name": "Path 78572",
    d: "M60.429,36.7l-.54.65-1.858,2.237L49.1,34.434l-.514-2.745-.206-1.1L48.51,30,56.5,33.521Z",
    transform: "translate(-12.217 -7.576)",
    fill: "#e28b00"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78573",
    "data-name": "Path 78573",
    d: "M60.429,36.7l-.54.65L58.4,36.7l-.09.1-.566.675-9.1-5.561-.064-.225-.206-1.1L48.51,30,56.5,33.521Z",
    transform: "translate(-12.217 -7.576)",
    fill: "#bb5300"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78574",
    "data-name": "Path 78574",
    d: "M60.68,36.366l-.244-.108-.833-.369-2.13-.946-.184-.081-.087.1-.571.677-4.177-2.555-4.69-2.869-.227-.139-.4-1.428-1.613-1.208.427-1.159,1.075.62,4.626,2.671,6.881,3.974.03.017,1.5.866.357,1.118.179.56Z",
    transform: "translate(-11.494 -6.636)",
    fill: "#bc998e"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78575",
    "data-name": "Path 78575",
    d: "M100.718,59.265l-.187.173-.117.108-.046.042-1.89,1.745-1.234.649h0L93.615,57.82h0l-1.225-1.4L91.234,55.09l-1.628-1.866-.779-.894.126-.585,3.778,1.662,5.407,3.122,2.214,2.347Z",
    transform: "translate(-22.429 -13.066)",
    fill: "#b74200"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78576",
    "data-name": "Path 78576",
    d: "M100.628,58.558l-.706.539-.2-.151-2.485-1.894-.029.034-.493.587-.134.159-.707.539-5.333-3.88-3.055-2.223-.088-.31-.316-1.118-.993-1.467L88.5,50.767l1.032.6,2.506,1.446,5.407,3.121,1.408.813q.2.114.394.242a9.984,9.984,0,0,1,1.16.883Z",
    transform: "translate(-21.738 -12.467)",
    fill: "#9b7a6d"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78577",
    "data-name": "Path 78577",
    d: "M99.223,59.313l-.54.65L96.825,62.2,87.9,57.044,87.381,54.3l-.206-1.1.129-.585,7.984,3.516Z",
    transform: "translate(-22.012 -13.285)",
    fill: "#ce5d3a"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78578",
    "data-name": "Path 78578",
    d: "M99.223,59.313l-.54.65L97.2,59.306l-.09.1-.565.675-9.1-5.561-.064-.225-.206-1.1.129-.585,7.984,3.516Z",
    transform: "translate(-22.012 -13.285)",
    fill: "#a33400"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78579",
    "data-name": "Path 78579",
    d: "M99.474,58.932l-.245-.108-.831-.369-2.13-.946-.185-.082-.086.1-.571.677L91.25,55.651l-4.69-2.869-.227-.139-.4-1.428-1.612-1.208.475-1.289.7.405.15.086L88.054,50.6l1.032.6,2.506,1.446L97,55.764l1.408.813c.132.076.263.156.393.241l.413,1.292.179.561Z",
    transform: "translate(-21.29 -12.301)",
    fill: "#bc998e"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78580",
    "data-name": "Path 78580",
    d: "M107.791,66.836c0,1.568-1.109,2.2-2.476,1.411a5.457,5.457,0,0,1-2.475-4.269c0-1.568,1.109-2.2,2.475-1.411a5.454,5.454,0,0,1,2.476,4.269",
    transform: "translate(-25.968 -15.713)",
    fill: "#4f1f26"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78581",
    "data-name": "Path 78581",
    d: "M107.161,65.244l-1.236.537a4.346,4.346,0,0,1,.522,2.175c-.034,1.257-.25,1.163-.25,1.163l-1.281.443-3.194-6.17,1.7-1.038L105.39,63.4Z",
    transform: "translate(-25.685 -15.745)",
    fill: "#4f1f26"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78582",
    "data-name": "Path 78582",
    d: "M105.637,68.169c0,1.568-1.108,2.2-2.475,1.411a5.453,5.453,0,0,1-2.475-4.268c0-1.568,1.109-2.2,2.475-1.411a5.453,5.453,0,0,1,2.475,4.269",
    transform: "translate(-25.424 -16.049)",
    fill: "#ba9c8c"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78583",
    "data-name": "Path 78583",
    d: "M105.193,68.073c0,1.144-.808,1.6-1.8,1.029a3.975,3.975,0,0,1-1.8-3.112c0-1.144.807-1.6,1.8-1.029a3.974,3.974,0,0,1,1.8,3.112",
    transform: "translate(-25.651 -16.34)",
    fill: "#8c7370"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78584",
    "data-name": "Path 78584",
    d: "M60.253,61.455,15.272,35.485c-1.877-1.083-3.571-1.271-4.778-.7v0l-.025.015a2.9,2.9,0,0,0-.369.212L2.035,39.659l.862.811,2.922,3.3c.158,3.663,4.868,3.7,8.432,5.76l40.755,23.53,2.006,7.191,8.127-4.692c.07-.037.138-.076.2-.118l.025-.014-1.02.588c.952-.614,2.544-2.367,2.544-4,0-3.715-2.972-8.443-6.639-10.56",
    transform: "translate(-0.514 -8.704)",
    fill: "#4f1f26"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78585",
    "data-name": "Path 78585",
    d: "M10.97,36.73,16.9,35.571a9.407,9.407,0,0,0-.736-.739L10.51,35.976,7.671,39.882l.413.782Z",
    transform: "translate(-1.937 -8.795)",
    fill: "#5d3138"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78586",
    "data-name": "Path 78586",
    d: "M15.917,39.546l5.932-1.159a9.406,9.406,0,0,0-.736-.739l-5.656,1.144L12.618,42.7l.412.782Z",
    transform: "translate(-3.186 -9.506)",
    fill: "#5d3138"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78587",
    "data-name": "Path 78587",
    d: "M20.865,42.361,26.8,41.2a9.275,9.275,0,0,0-.736-.739L20.4,41.607l-2.838,3.906.411.782Z",
    transform: "translate(-4.435 -10.217)",
    fill: "#5d3138"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78588",
    "data-name": "Path 78588",
    d: "M25.813,45.176l5.931-1.159a9.145,9.145,0,0,0-.736-.739l-5.656,1.144-2.837,3.906.41.782Z",
    transform: "translate(-5.685 -10.928)",
    fill: "#5d3138"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78589",
    "data-name": "Path 78589",
    d: "M30.76,47.991l5.932-1.159a9.274,9.274,0,0,0-.736-.739L30.3,47.237l-2.838,3.906.412.782Z",
    transform: "translate(-6.934 -11.639)",
    fill: "#5d3138"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78590",
    "data-name": "Path 78590",
    d: "M35.706,50.806l5.932-1.159a9.4,9.4,0,0,0-.736-.739l-5.656,1.144-2.839,3.906.412.782Z",
    transform: "translate(-8.183 -12.349)",
    fill: "#5d3138"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78591",
    "data-name": "Path 78591",
    d: "M40.654,53.622l5.931-1.159a9.5,9.5,0,0,0-.736-.739l-5.656,1.144-2.84,3.906.412.782Z",
    transform: "translate(-9.432 -13.061)",
    fill: "#5d3138"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78592",
    "data-name": "Path 78592",
    d: "M45.6,56.437l5.932-1.159a9.273,9.273,0,0,0-.736-.739l-5.656,1.144L42.3,59.589l.411.782Z",
    transform: "translate(-10.682 -13.771)",
    fill: "#5d3138"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78593",
    "data-name": "Path 78593",
    d: "M50.549,59.252l5.932-1.159a9.276,9.276,0,0,0-.736-.739L50.088,58.5,47.25,62.4l.411.782Z",
    transform: "translate(-11.931 -14.482)",
    fill: "#5d3138"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78594",
    "data-name": "Path 78594",
    d: "M55.5,62.067l5.932-1.159a9.277,9.277,0,0,0-.736-.739l-5.656,1.144L52.2,65.219l.411.782Z",
    transform: "translate(-13.18 -15.193)",
    fill: "#5d3138"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78595",
    "data-name": "Path 78595",
    d: "M60.443,64.883l5.932-1.159a9.409,9.409,0,0,0-.736-.739l-5.656,1.144-2.839,3.906.412.782Z",
    transform: "translate(-14.429 -15.904)",
    fill: "#5d3138"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78596",
    "data-name": "Path 78596",
    d: "M65.39,67.7l5.932-1.159a9.4,9.4,0,0,0-.736-.739L64.93,66.944,62.091,70.85l.413.782Z",
    transform: "translate(-15.678 -16.615)",
    fill: "#5d3138"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78597",
    "data-name": "Path 78597",
    d: "M70.338,70.513l5.932-1.159a9.275,9.275,0,0,0-.736-.739l-5.656,1.144-2.838,3.906.411.782Z",
    transform: "translate(-16.928 -17.326)",
    fill: "#5d3138"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78598",
    "data-name": "Path 78598",
    d: "M75.218,73.4l5.932-1.159a9.274,9.274,0,0,0-.736-.739l-5.656,1.144-2.838,3.906.412.782Z",
    transform: "translate(-18.16 -18.056)",
    fill: "#5d3138"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78599",
    "data-name": "Path 78599",
    d: "M78.647,77.949l5.932-1.159a9.276,9.276,0,0,0-.736-.739L78.186,77.2,75.348,81.1l.411.782Z",
    transform: "translate(-19.026 -19.203)",
    fill: "#5d3138"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78600",
    "data-name": "Path 78600",
    d: "M80.244,83.118l5.932-1.159a9.408,9.408,0,0,0-.736-.739l-5.656,1.144L76.945,86.27l.412.782Z",
    transform: "translate(-19.429 -20.508)",
    fill: "#5d3138"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78601",
    "data-name": "Path 78601",
    d: "M80.315,88.81l5.932-1.159a9.276,9.276,0,0,0-.736-.739l-5.656,1.144-2.838,3.906.411.782Z",
    transform: "translate(-19.447 -21.946)",
    fill: "#5d3138"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78602",
    "data-name": "Path 78602",
    d: "M6.639,41.755l44.981,25.97c3.667,2.117,6.64,6.845,6.64,10.56s-2.973,5.01-6.64,2.893L6.639,55.208C2.972,53.09,0,48.362,0,44.648s2.972-5.01,6.639-2.894",
    transform: "translate(0 -10.286)",
    fill: "#816065"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78603",
    "data-name": "Path 78603",
    d: "M57.362,78.089a4.3,4.3,0,0,1-.093.915c-.464,2.121-2.615,2.692-5.191,1.2L7.1,54.239c-2.912-1.682-5.283-5.369-5.283-8.219,0-2.466,1.775-3.509,4.14-2.656A7.171,7.171,0,0,1,7.1,43.9l44.981,25.97c2.914,1.682,5.283,5.369,5.283,8.219",
    transform: "translate(-0.458 -10.875)",
    fill: "#4f1f26"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78604",
    "data-name": "Path 78604",
    d: "M58.729,78.189a4.3,4.3,0,0,1-.093.915,7.088,7.088,0,0,1-1.142-.538L12.513,52.6C9.6,50.915,7.23,47.227,7.23,44.377a4.3,4.3,0,0,1,.093-.914A7.17,7.17,0,0,1,8.465,44l2.319,1.34,1.075.62,4.626,2.67L23.366,52.6l.03.016,1.5.866,1.076.622,3.015,1.742,4.8,2.77,6.044,3.488.7.406.149.086,2.412,1.393,1.032.6,2.506,1.446,5.407,3.121,1.408.813c.132.076.264.156.394.241a9.907,9.907,0,0,1,1.16.884c2.157,1.9,3.729,4.773,3.729,7.094",
    transform: "translate(-1.826 -10.975)",
    fill: "#380009"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78605",
    "data-name": "Path 78605",
    d: "M41.281,70.293c0,1.208-.853,1.694-1.905,1.087a4.2,4.2,0,0,1-1.906-3.287c0-1.207.854-1.694,1.906-1.086a4.2,4.2,0,0,1,1.905,3.287",
    transform: "translate(-9.461 -16.853)",
    fill: "#ba9c8c"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78606",
    "data-name": "Path 78606",
    d: "M41.174,69.954c0,1.031-.728,1.446-1.627.928a3.586,3.586,0,0,1-1.627-2.806c0-1.031.729-1.446,1.627-.928a3.585,3.585,0,0,1,1.627,2.806",
    transform: "translate(-9.575 -16.899)",
    fill: "#8c7370"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78607",
    "data-name": "Path 78607",
    d: "M13.337,51.223c0,1.568-1.108,2.2-2.475,1.411a5.455,5.455,0,0,1-2.475-4.269c0-1.568,1.109-2.2,2.475-1.411a5.453,5.453,0,0,1,2.475,4.269",
    transform: "translate(-2.118 -11.77)",
    fill: "#4f1f26"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78608",
    "data-name": "Path 78608",
    d: "M12.707,49.631l-1.236.537a4.346,4.346,0,0,1,.522,2.175c-.034,1.257-.25,1.163-.25,1.163l-1.281.443-3.194-6.17,1.7-1.038,1.967,1.049Z",
    transform: "translate(-1.835 -11.802)",
    fill: "#4f1f26"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78609",
    "data-name": "Path 78609",
    d: "M11.183,52.557c0,1.568-1.108,2.2-2.475,1.411A5.455,5.455,0,0,1,6.233,49.7c0-1.568,1.109-2.2,2.475-1.411a5.453,5.453,0,0,1,2.475,4.269",
    transform: "translate(-1.574 -12.107)",
    fill: "#ba9c8c"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78610",
    "data-name": "Path 78610",
    d: "M10.739,52.461c0,1.144-.808,1.6-1.8,1.029a3.974,3.974,0,0,1-1.8-3.112c0-1.144.807-1.6,1.8-1.029a3.974,3.974,0,0,1,1.8,3.112",
    transform: "translate(-1.801 -12.398)",
    fill: "#8c7370"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78611",
    "data-name": "Path 78611",
    d: "M52.925,73.65c0,1.568-1.108,2.2-2.475,1.411a5.455,5.455,0,0,1-2.475-4.269c0-1.568,1.109-2.2,2.475-1.411a5.453,5.453,0,0,1,2.475,4.269",
    transform: "translate(-12.114 -17.433)",
    fill: "#4f1f26"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78612",
    "data-name": "Path 78612",
    d: "M52.295,72.058l-1.236.537a4.346,4.346,0,0,1,.522,2.175c-.034,1.257-.25,1.163-.25,1.163l-1.281.443-3.194-6.17,1.7-1.038,1.966,1.049Z",
    transform: "translate(-11.831 -17.465)",
    fill: "#4f1f26"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78613",
    "data-name": "Path 78613",
    d: "M50.771,74.983c0,1.568-1.108,2.2-2.475,1.411a5.455,5.455,0,0,1-2.475-4.269c0-1.568,1.109-2.2,2.475-1.411a5.453,5.453,0,0,1,2.475,4.269",
    transform: "translate(-11.57 -17.77)",
    fill: "#ba9c8c"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78614",
    "data-name": "Path 78614",
    d: "M50.327,74.887c0,1.144-.808,1.6-1.8,1.029a3.974,3.974,0,0,1-1.8-3.112c0-1.144.807-1.6,1.8-1.029a3.974,3.974,0,0,1,1.8,3.112",
    transform: "translate(-11.797 -18.061)",
    fill: "#8c7370"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78615",
    "data-name": "Path 78615",
    d: "M34.909,63.378c0,1.568-1.108,2.2-2.475,1.411a5.455,5.455,0,0,1-2.475-4.269c0-1.568,1.109-2.2,2.475-1.411a5.453,5.453,0,0,1,2.475,4.269",
    transform: "translate(-7.565 -14.84)",
    fill: "#4f1f26"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78616",
    "data-name": "Path 78616",
    d: "M34.28,61.786l-1.236.537a4.346,4.346,0,0,1,.522,2.175c-.034,1.257-.25,1.163-.25,1.163l-1.281.443-3.194-6.17,1.7-1.038,1.967,1.049Z",
    transform: "translate(-7.282 -14.872)",
    fill: "#4f1f26"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78617",
    "data-name": "Path 78617",
    d: "M32.756,64.711c0,1.568-1.108,2.2-2.475,1.411a5.455,5.455,0,0,1-2.475-4.269c0-1.568,1.109-2.2,2.475-1.411a5.453,5.453,0,0,1,2.475,4.269",
    transform: "translate(-7.021 -15.176)",
    fill: "#ba9c8c"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78618",
    "data-name": "Path 78618",
    d: "M32.312,64.615c0,1.144-.808,1.6-1.8,1.029a3.974,3.974,0,0,1-1.8-3.112c0-1.144.807-1.6,1.8-1.029a3.974,3.974,0,0,1,1.8,3.112",
    transform: "translate(-7.248 -15.467)",
    fill: "#8c7370"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78619",
    "data-name": "Path 78619",
    d: "M53.1,69.71l-.989.912L49.814,71.83v0h0l-6.746-7.735-.306-.35L49.5,67.635l2.562,1.479Z",
    transform: "translate(-10.797 -16.095)",
    fill: "#b74200"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78620",
    "data-name": "Path 78620",
    d: "M48.555,67.087,46.3,69.8h0L29.7,60.214l-.842-4.5,5.594,3.23,4.8,2.77,6.745,3.894Z",
    transform: "translate(-7.287 -14.068)",
    fill: "#ce5d3a"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78621",
    "data-name": "Path 78621",
    d: "M47.883,66.7l-.218.259-6.221-3.8-5.1-3.12,4.8,2.77Z",
    transform: "translate(-9.176 -15.159)",
    fill: "#a33400"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78622",
    "data-name": "Path 78622",
    d: "M18.819,57.29c0,1.208-.853,1.694-1.905,1.087a4.2,4.2,0,0,1-1.906-3.287c0-1.207.854-1.694,1.906-1.086a4.2,4.2,0,0,1,1.905,3.287",
    transform: "translate(-3.79 -13.57)",
    fill: "#ba9c8c"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78623",
    "data-name": "Path 78623",
    d: "M18.713,56.951c0,1.031-.728,1.446-1.627.928a3.586,3.586,0,0,1-1.627-2.806c0-1.031.729-1.446,1.627-.928a3.585,3.585,0,0,1,1.627,2.806",
    transform: "translate(-3.903 -13.615)",
    fill: "#8c7370"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78624",
    "data-name": "Path 78624",
    d: "M25.365,61.305c0,1.208-.853,1.694-1.905,1.087A4.2,4.2,0,0,1,21.554,59.1c0-1.207.854-1.694,1.906-1.086a4.2,4.2,0,0,1,1.905,3.287",
    transform: "translate(-5.442 -14.584)",
    fill: "#ba9c8c"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78625",
    "data-name": "Path 78625",
    d: "M25.258,60.966c0,1.031-.728,1.446-1.627.928A3.586,3.586,0,0,1,22,59.087c0-1.031.729-1.446,1.627-.928a3.585,3.585,0,0,1,1.627,2.806",
    transform: "translate(-5.556 -14.629)",
    fill: "#8c7370"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78626",
    "data-name": "Path 78626",
    d: "M57.657,79.155c0,1.208-.853,1.694-1.905,1.086a4.2,4.2,0,0,1-1.906-3.287c0-1.207.854-1.694,1.906-1.086a4.2,4.2,0,0,1,1.905,3.287",
    transform: "translate(-13.596 -19.091)",
    fill: "#ba9c8c"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78627",
    "data-name": "Path 78627",
    d: "M57.551,78.816c0,1.031-.728,1.446-1.627.928A3.586,3.586,0,0,1,54.3,76.937c0-1.031.729-1.446,1.627-.928a3.585,3.585,0,0,1,1.627,2.806",
    transform: "translate(-13.71 -19.136)",
    fill: "#8c7370"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78628",
    "data-name": "Path 78628",
    d: "M64.2,83.17c0,1.208-.853,1.695-1.905,1.087a4.2,4.2,0,0,1-1.906-3.287c0-1.207.854-1.694,1.906-1.086A4.2,4.2,0,0,1,64.2,83.17",
    transform: "translate(-15.249 -20.105)",
    fill: "#ba9c8c"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78629",
    "data-name": "Path 78629",
    d: "M64.1,82.831c0,1.031-.728,1.446-1.627.928a3.586,3.586,0,0,1-1.627-2.806c0-1.031.729-1.446,1.627-.928A3.585,3.585,0,0,1,64.1,82.831",
    transform: "translate(-15.363 -20.15)",
    fill: "#8c7370"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78630",
    "data-name": "Path 78630",
    d: "M27.817,56.349l-.187.172-.116.107-.046.043-1.892,1.745-1.234.65v0h0L20.714,54.9h0l-1.227-1.4-1.153-1.323-1.627-1.866h0l-.78-.894.126-.585,2.629,1.156,6.881,3.974,1.888,2Z",
    transform: "translate(-4.021 -12.329)",
    fill: "#b74200"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78631",
    "data-name": "Path 78631",
    d: "M27.786,55.728l-.706.538-.2-.15L24.4,54.222l-.03.035-.493.586L23.74,55l-.707.539L17.7,51.664,14.645,49.44l-.088-.311-.316-1.118L13.423,46.8l4.626,2.67,6.881,3.974.029.016,1.5.866,1.076.622Z",
    transform: "translate(-3.389 -11.818)",
    fill: "#9b7a6d"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78632",
    "data-name": "Path 78632",
    d: "M26.322,56.4l-.54.65-1.858,2.236-8.93-5.155-.514-2.745-.206-1.1L14.4,49.7l7.984,3.517Z",
    transform: "translate(-3.604 -12.548)",
    fill: "#ce7731"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78633",
    "data-name": "Path 78633",
    d: "M26.322,56.4l-.54.65L24.3,56.388l-.09.1-.565.675-9.1-5.561-.064-.225-.206-1.1L14.4,49.7l7.984,3.517Z",
    transform: "translate(-3.604 -12.548)",
    fill: "#a33400"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78634",
    "data-name": "Path 78634",
    d: "M26.573,56.058l-.244-.108L25.5,55.58l-2.13-.946-.184-.081-.087.1-.571.677-4.177-2.555-4.69-2.869-.227-.139-.4-1.428-1.613-1.208.427-1.159,1.075.62,4.626,2.671,6.881,3.974.03.017,1.5.866.357,1.118.179.56Z",
    transform: "translate(-2.882 -11.609)",
    fill: "#bc998e"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78635",
    "data-name": "Path 78635",
    d: "M66.611,78.957l-.187.172-.117.108-.046.042-1.89,1.745-1.234.649h0l-3.627-4.159h0l-1.225-1.4-1.154-1.325L55.5,72.916l-.779-.894.126-.585L58.624,73.1l5.407,3.122,2.214,2.347Z",
    transform: "translate(-13.817 -18.038)",
    fill: "#b74200"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78636",
    "data-name": "Path 78636",
    d: "M66.521,78.25l-.706.539-.2-.151L63.13,76.744l-.029.034-.493.587-.134.159-.707.539-5.333-3.88L53.38,71.96l-.088-.31-.316-1.118-.993-1.467,2.412,1.393,1.032.6L57.932,72.5l5.407,3.122,1.408.813q.2.114.394.242a9.979,9.979,0,0,1,1.16.883Z",
    transform: "translate(-13.126 -17.439)",
    fill: "#9b7a6d"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78637",
    "data-name": "Path 78637",
    d: "M65.116,79l-.54.65L62.718,81.89l-8.93-5.155-.514-2.745-.206-1.1.129-.585,7.985,3.517Z",
    transform: "translate(-13.4 -18.257)",
    fill: "#ce7731"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78638",
    "data-name": "Path 78638",
    d: "M65.116,79l-.54.65L63.091,79l-.09.1-.566.675-9.1-5.561-.064-.225-.206-1.1.129-.585,7.985,3.517Z",
    transform: "translate(-13.4 -18.257)",
    fill: "#a33400"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78639",
    "data-name": "Path 78639",
    d: "M65.367,78.622l-.244-.108-.832-.369-2.13-.946-.184-.082-.087.1-.571.677-4.177-2.555-4.69-2.869-.227-.139-.4-1.428L50.209,69.7l.475-1.29.7.406.15.086,2.412,1.393,1.032.6,2.506,1.446,5.407,3.121,1.408.813c.132.076.263.156.393.241l.413,1.292.179.561Z",
    transform: "translate(-12.678 -17.273)",
    fill: "#bc998e"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78640",
    "data-name": "Path 78640",
    d: "M73.683,86.528c0,1.568-1.108,2.2-2.475,1.411a5.456,5.456,0,0,1-2.475-4.269c0-1.568,1.109-2.2,2.475-1.411a5.453,5.453,0,0,1,2.475,4.269",
    transform: "translate(-17.355 -20.685)",
    fill: "#4f1f26"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78641",
    "data-name": "Path 78641",
    d: "M73.054,84.935l-1.236.537a4.337,4.337,0,0,1,.522,2.175c-.034,1.257-.25,1.163-.25,1.163l-1.281.443-3.194-6.17,1.7-1.038,1.967,1.049Z",
    transform: "translate(-17.073 -20.717)",
    fill: "#4f1f26"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78642",
    "data-name": "Path 78642",
    d: "M71.53,87.861c0,1.568-1.108,2.2-2.475,1.411A5.455,5.455,0,0,1,66.58,85c0-1.568,1.109-2.2,2.475-1.411a5.453,5.453,0,0,1,2.475,4.269",
    transform: "translate(-16.812 -21.022)",
    fill: "#ba9c8c"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78643",
    "data-name": "Path 78643",
    d: "M71.086,87.765c0,1.144-.808,1.6-1.8,1.029a3.974,3.974,0,0,1-1.8-3.112c0-1.144.807-1.6,1.8-1.029a3.974,3.974,0,0,1,1.8,3.112",
    transform: "translate(-17.038 -21.313)",
    fill: "#8c7370"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78644",
    "data-name": "Path 78644",
    d: "M62.977,62.228l-5.358,3.1-16.025-10a32.081,32.081,0,0,1-8.824-2.27c-5.377-2.08-6.284-6.021-6.284-6.021L8.819,36.847l3.361-1.938L64.761,47.562,61,60.984Z",
    transform: "translate(-2.227 -8.815)",
    fill: "#380009"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78645",
    "data-name": "Path 78645",
    d: "M30.772,43.522H70.187v1.14h-.036c.2,3.063-1.714,6.171-5.779,8.518-7.719,4.458-20.2,4.479-27.872.05-4.069-2.35-5.946-5.479-5.679-8.568h-.049Z",
    transform: "translate(-7.77 -10.989)",
    fill: "#2d191d"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78646",
    "data-name": "Path 78646",
    d: "M36.5,47.748c7.674,4.429,20.152,4.408,27.872-.05s7.758-11.662.087-16.091-20.15-4.407-27.87.051S28.83,43.32,36.5,47.748",
    transform: "translate(-7.77 -7.146)",
    fill: "#4a3f40"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78647",
    "data-name": "Path 78647",
    d: "M160.977,33.165l-3.524-2.672-5.3-2.012v5.727l4.56,1.283,4.636-.462Z",
    transform: "translate(-38.419 -7.191)",
    fill: "#cb5200"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78648",
    "data-name": "Path 78648",
    d: "M157.454,30.331l.83-.479-5.3-2.012-.83.479Z",
    transform: "translate(-38.419 -7.03)",
    fill: "#ff9e42"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78649",
    "data-name": "Path 78649",
    d: "M151.081,28.318l.83-.479h-4l1.678.661Z",
    transform: "translate(-37.348 -7.029)",
    fill: "#ff9e42"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78650",
    "data-name": "Path 78650",
    d: "M151.648,34.207V28.48l-1.494.18v5.727Z",
    transform: "translate(-37.914 -7.191)",
    fill: "#ed8725"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78651",
    "data-name": "Path 78651",
    d: "M162.768,33.683l.83-.479-3.523-2.672-.83.479Z",
    transform: "translate(-40.21 -7.709)",
    fill: "#ffb357"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78652",
    "data-name": "Path 78652",
    d: "M163.958,34.586l.83-.479.371,1.864-.83.479Z",
    transform: "translate(-41.4 -8.612)",
    fill: "#ff9700"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78653",
    "data-name": "Path 78653",
    d: "M89.233,26.64l6.491-10.276,3.012-1.739,6.49-1.679,32.359,12.937,3.523,2.672.371,1.864-3.012,1.739-28.942-8.963-6.71.914L93.73,30.193l-1.576,4.3-3.012,1.739Z",
    transform: "translate(-22.509 -3.269)",
    fill: "#b84c21"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78654",
    "data-name": "Path 78654",
    d: "M109.643,12.946l-3.012,1.739,29.52,11.792,3.012-1.739Z",
    transform: "translate(-26.925 -3.269)",
    fill: "#f5a355"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78655",
    "data-name": "Path 78655",
    d: "M135.792,25.848,131.352,24h-.62l-13.187-5.573-.386-.674.847-.411,14.424,6.08.033.386,3.982,1.71Z",
    transform: "translate(-29.583 -4.379)",
    fill: "#a83c00"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78656",
    "data-name": "Path 78656",
    d: "M90.413,22.921l-.46-.366L94.885,16.4c.223-.106,5.471-2.628,7.4-2.311,1.869.3,9,2.878,9.306,2.988l-.2.552c-.073-.026-7.384-2.671-9.2-2.961-1.429-.229-5.473,1.506-6.992,2.232Z",
    transform: "translate(-22.714 -3.551)",
    fill: "#380009"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78657",
    "data-name": "Path 78657",
    d: "M92.229,21.653l-.46-.366L96.7,15.133c.222-.106,5.472-2.63,7.4-2.311,1.881.3,8.529,3.325,8.811,3.453l-.244.534c-.069-.031-6.858-3.121-8.66-3.408-1.441-.229-5.474,1.507-6.992,2.232Z",
    transform: "translate(-23.172 -3.231)",
    fill: "#380009"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78658",
    "data-name": "Path 78658",
    d: "M150.665,23.579l3.012-1.739,1.773-.054,5.077,7,9.8,39.646-3.012,1.739Z",
    transform: "translate(-38.043 -5.501)",
    fill: "#b84c21"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78659",
    "data-name": "Path 78659",
    d: "M163.305,34.244s-.284-.765-.546-.766-.978.251-.978.672,5.63,23.925,5.63,23.925l.712.312,2.9,12.023.468-.173-2.638-11.851a11.764,11.764,0,0,0-.093-1.239c-.077-.478-5.456-22.9-5.456-22.9",
    transform: "translate(-40.85 -8.453)",
    fill: "#a83c00"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78660",
    "data-name": "Path 78660",
    d: "M118.375,18.09a.524.524,0,0,0,.288.318c.159.056,15.936,3.013,15.936,3.013l.275-1.923s-15.7-2.948-15.817-2.986a.455.455,0,0,0-.49.216,1.52,1.52,0,0,0-.191,1.361",
    transform: "translate(-29.869 -4.165)",
    fill: "#ed8725"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78661",
    "data-name": "Path 78661",
    d: "M139.6,22.1c.164.405.517.451.786.1a1.52,1.52,0,0,0,.191-1.361.419.419,0,0,0-.786-.1A1.52,1.52,0,0,0,139.6,22.1",
    transform: "translate(-35.228 -5.178)",
    fill: "#ff9700"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78662",
    "data-name": "Path 78662",
    d: "M151.26,24.223l.058-1L140.49,21.152a.5.5,0,0,0-.594.463.492.492,0,0,0,.4.512Z",
    transform: "translate(-35.324 -5.339)",
    fill: "#896a6d"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78663",
    "data-name": "Path 78663",
    d: "M150.153,31.566l.383-7.4,1.773-.054,5.076,7,9.8,39.646-1.843.26Z",
    transform: "translate(-37.914 -6.089)",
    fill: "#d37d33"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78664",
    "data-name": "Path 78664",
    d: "M156.694,38.325l-1.342,1.337-1.2.881-1.214.245-2.78-7.218.078-1.521,3.192,1.3,2.441,2.125Z",
    transform: "translate(-37.914 -8.092)",
    fill: "#a83c00"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78665",
    "data-name": "Path 78665",
    d: "M84.655,28.966l9.5-12.014,6.49-1.679L130.17,27.064l-.012,5.549-25.21-7.093-6.71.914L89.152,32.52l-1.576,4.3L82.94,32.816Z",
    transform: "translate(-20.943 -3.856)",
    fill: "#ce7731"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78666",
    "data-name": "Path 78666",
    d: "M154.317,37.011l-3.523-2.672-5.3-2.012v5.727l4.56,1.283,4.636-.462Z",
    transform: "translate(-36.737 -8.162)",
    fill: "#ce7731"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78667",
    "data-name": "Path 78667",
    d: "M150.794,34.176l.83-.479-5.3-2.012-.83.479Z",
    transform: "translate(-36.737 -8.001)",
    fill: "#ff9e42"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78668",
    "data-name": "Path 78668",
    d: "M145.092,31.614l.83-.479-1.186-1.627-.83.479Z",
    transform: "translate(-36.337 -7.451)",
    fill: "#ff9e42"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78669",
    "data-name": "Path 78669",
    d: "M145.092,37.5V31.776l-1.186-1.627v5.727Z",
    transform: "translate(-36.337 -7.613)",
    fill: "#ed8725"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78670",
    "data-name": "Path 78670",
    d: "M156.108,37.529l.83-.479-3.523-2.672-.83.479Z",
    transform: "translate(-38.528 -8.68)",
    fill: "#dd6617"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78671",
    "data-name": "Path 78671",
    d: "M157.3,38.431l.83-.479.371,1.864-.83.479Z",
    transform: "translate(-39.718 -9.583)",
    fill: "#b84c21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_72772",
    "data-name": "Group 72772",
    transform: "translate(76.911 14.448)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_72771",
    "data-name": "Group 72771"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72770",
    "data-name": "Group 72770",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78672",
    "data-name": "Path 78672",
    d: "M106.809,19.741l-2.918,7.635-.614.084-.384.257,1.542-4.855,1.582-3.533Z",
    transform: "translate(-102.892 -19.329)",
    fill: "#beb5af"
  }))))), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78673",
    "data-name": "Path 78673",
    d: "M174.761,83.92l1.863.429,1.257,1.869,1.993,10.4s-.477,2.459-.477,2.856-11.238,6.6-11.238,6.6l.97-11.237L157.908,83.2l5.546,3.336,4.27.252Z",
    transform: "translate(-39.872 -21.009)",
    fill: "#2f2728"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78674",
    "data-name": "Path 78674",
    d: "M168.772,84.844l-11.027,6.365-4.776,1.949-4.27-.252-5.545-3.335.485-.28,3.435,2.066,10.06-5.808L153.7,83.483l.484-.28,5.546,3.335,4.271.253Z",
    transform: "translate(-36.147 -21.009)",
    fill: "#49383b"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78675",
    "data-name": "Path 78675",
    d: "M146.233,89.849h0l-.485.28Z",
    transform: "translate(-36.802 -22.687)",
    fill: "#362e2f"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78676",
    "data-name": "Path 78676",
    d: "M164.934,88.052l-1.941,1.12-2.086,1.2-.135.078h0l-1.319.762-.486.28-.112.065-.413.169-1.942.793-.034.013-1.05.429-1.2.49-.289-.016-3.668-.218-.082,0L148.4,92.15l10.059-5.808,2.11,1.269.335.2Z",
    transform: "translate(-37.471 -21.802)",
    fill: "#362e2f"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78677",
    "data-name": "Path 78677",
    d: "M164.578,88.852l-2.223,1.283h0l-1.319.762-.484.28h0l-1.174-1.218-4.709-4.883,1.8,1.08h0l3.747,2.254.335.2,4.03.239Z",
    transform: "translate(-39.054 -21.482)",
    fill: "#2d191d"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78678",
    "data-name": "Path 78678",
    d: "M161.6,90.569l-1.319.762-.484.28h0l-.112.065-.413.169-1.942.793-.929-.963-4.708-4.882,1.8,1.08v0l3.748,2.254.335.2,1.051.063Z",
    transform: "translate(-38.303 -21.915)",
    fill: "#2d191d"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78679",
    "data-name": "Path 78679",
    d: "M158.522,92.277l-1.942.793-.033.014-1.051.428-1.2.491-.289-.017-5.285-5.479,1.8,1.08v0l3.747,2.254.335.2,1.05.063Z",
    transform: "translate(-37.552 -22.348)",
    fill: "#2d191d"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78680",
    "data-name": "Path 78680",
    d: "M154.746,93.946l-1.2.49-3.957-.234-3.838-3.979,1.8,1.08h0l3.748,2.254.335.2Z",
    transform: "translate(-36.802 -22.782)",
    fill: "#2d191d"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78681",
    "data-name": "Path 78681",
    d: "M164.265,87.637l-4.032-.239-.335-.2-2.11-1.268-1.455.84L152.9,84.7l-.485.28,1.8,1.08h0l1.637.985-1.737,1-3.435-2.067-.484.28,1.8,1.08h0l1.637.985-1.737,1-3.435-2.067-.485.28,1.8,1.08h0l1.638.985-1.737,1-3.436-2.067-.484.28,1.8,1.08h0l1.639.985-1.455.84L149.5,92.8l.082,0,3.668.218.289.016,1.2-.49h0l1.049-.429.034-.013,1.94-.793.415-.169.6-.345,1.319-.762h0l.771-.446h0l1.45-.837h0l.77-.445Z",
    transform: "translate(-36.802 -21.387)",
    fill: "#352428"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78682",
    "data-name": "Path 78682",
    d: "M167.172,87.354,163.629,89.4l-.484.28-5.885-6.1,1.8,1.08h0l3.747,2.254.335.2Z",
    transform: "translate(-39.709 -21.104)",
    fill: "#2d191d"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78683",
    "data-name": "Path 78683",
    d: "M159.956,88.263s-2.3.173-2.678.182a11.8,11.8,0,0,0-2.18,1.246l-2.18,2.144-1.931,1.126-1.1.342.745.4,3.957.235,4.754-1.961,4.027-2.324-1.934-.395Z",
    transform: "translate(-37.847 -22.287)",
    fill: "#47220b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_72775",
    "data-name": "Group 72775",
    transform: "translate(112.039 67.07)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_72774",
    "data-name": "Group 72774"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72773",
    "data-name": "Group 72773",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78684",
    "data-name": "Path 78684",
    d: "M161.9,89.726l-1.1.781-2.02.739-.7.809-2.938,1.109-3.69.442-.467-.274-1.1.342.744.4,3.958.234,4.754-1.961,4.027-2.324Z",
    transform: "translate(-149.886 -89.726)",
    fill: "#b09287"
  }))))), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78685",
    "data-name": "Path 78685",
    d: "M179.083,86.46l-1.257-1.869-1.863-.429h0l-2.26.923-11.027,6.366,2.261-.923h0l1.863.429,1.257,1.869,1.993,10.4-.477,2.856L180.6,99.714l.476-2.857Z",
    transform: "translate(-41.076 -21.251)",
    fill: "#3a2227"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78686",
    "data-name": "Path 78686",
    d: "M180.9,87.237,169.872,93.6l1.993,10.4,11.029-6.368Z",
    transform: "translate(-42.894 -22.028)",
    fill: "#493538"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78687",
    "data-name": "Path 78687",
    d: "M168.192,91.1l1.257,1.869,11.029-6.367-1.257-1.869Z",
    transform: "translate(-42.469 -21.396)",
    fill: "#5b4548"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78688",
    "data-name": "Path 78688",
    d: "M178.591,84.592l-11.029,6.367L165.7,90.53l11.029-6.367Z",
    transform: "translate(-41.84 -21.251)",
    fill: "#49383c"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78689",
    "data-name": "Path 78689",
    d: "M160.006,92.439l1.863.429,1.257,1.869,1.993,10.4-.477,2.856c0,.4-2.816,1.407-4.462.556s-5.805-5.191-5.805-5.191L143.153,91.722l5.546,3.336,4.27.252Z",
    transform: "translate(-36.147 -23.16)",
    fill: "#2d191d"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78690",
    "data-name": "Path 78690",
    d: "M163.789,108.36a2.323,2.323,0,0,1-1.039-.2,38.54,38.54,0,0,1-5.5-4.96L151.2,96.92l4,.236,6.939-2.831,1.047.241.864,1.284,1.908,9.955-.368,2.207a5.163,5.163,0,0,1-1.8.348",
    transform: "translate(-38.178 -23.817)",
    fill: "#23191d"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78691",
    "data-name": "Path 78691",
    d: "M164.215,108.851a2.323,2.323,0,0,1-1.039-.2,38.539,38.539,0,0,1-5.5-4.96l-5.638-5.845-.845-.05,6.057,6.28a38.537,38.537,0,0,0,5.5,4.96,2.315,2.315,0,0,0,1.039.2,5.143,5.143,0,0,0,1.8-.348l.043-.253a5.12,5.12,0,0,1-1.415.216",
    transform: "translate(-38.178 -24.694)",
    fill: "#352a2d"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78692",
    "data-name": "Path 78692",
    d: "M179.063,85.706l-.277-3.33.638-.369.277,3.33Z",
    transform: "translate(-45.144 -20.707)",
    fill: "#3a2227"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78693",
    "data-name": "Path 78693",
    d: "M178.144,82.231l-1.9-.431.638-.369,1.9.431Z",
    transform: "translate(-44.502 -20.562)",
    fill: "#3a2227"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78694",
    "data-name": "Path 78694",
    d: "M173.917,82.519l1.739-.72.638-.368-1.739.72Z",
    transform: "translate(-43.915 -20.562)",
    fill: "#3a2227"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78695",
    "data-name": "Path 78695",
    d: "M177.557,82.355l-1.9-.431-1.739.72.7,3.146,1.313-.536,1.9.431Z",
    transform: "translate(-43.915 -20.686)",
    fill: "#2d191d"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78696",
    "data-name": "Path 78696",
    d: "M180.148,90.605l-.193-1.079.386-.223.194,1.079Z",
    transform: "translate(-45.439 -22.55)",
    fill: "#4a3f40"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78697",
    "data-name": "Path 78697",
    d: "M179.691,89.339l-.782-.555.386-.223.782.555Z",
    transform: "translate(-45.175 -22.362)",
    fill: "#3a2227"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78698",
    "data-name": "Path 78698",
    d: "M177.766,89.223l.854-.438.386-.223-.854.438Z",
    transform: "translate(-44.887 -22.362)",
    fill: "#3a2227"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78699",
    "data-name": "Path 78699",
    d: "M179.4,89.415l-.782-.555-.854.438.854,1.143.269.671.706-.619Z",
    transform: "translate(-44.887 -22.438)",
    fill: "#2d191d"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78700",
    "data-name": "Path 78700",
    d: "M179.711,80.551l-8.467-7.691.36,1.9L178.443,81l.093,1.362-1.852,2.851.333,1.6,2.864-4.5Z",
    transform: "translate(-43.24 -18.397)",
    fill: "#ea7513"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78701",
    "data-name": "Path 78701",
    d: "M182.741,84.782l-.169-1.757.638-.369.169,1.757Z",
    transform: "translate(-46.1 -20.871)",
    fill: "#cb5200"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78702",
    "data-name": "Path 78702",
    d: "M181.83,85.375l-2.864,4.5.638-.369,2.864-4.5Z",
    transform: "translate(-45.19 -21.465)",
    fill: "#b84c21"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78703",
    "data-name": "Path 78703",
    d: "M179.711,80.426l-8.467-7.691.638-.369,8.467,7.691Z",
    transform: "translate(-43.24 -18.273)",
    fill: "#f5a355"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78704",
    "data-name": "Path 78704",
    d: "M182.062,84.439a.357.357,0,0,1-.1.276,3.582,3.582,0,0,1-.371.238l-.669-1.148a3.378,3.378,0,0,0,.3-.19.312.312,0,0,1,.367.011,1.037,1.037,0,0,1,.472.813",
    transform: "translate(-45.684 -21.099)",
    fill: "#380009"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78705",
    "data-name": "Path 78705",
    d: "M181.688,84.718c0,.3-.211.419-.472.269a1.041,1.041,0,0,1-.472-.814c0-.3.212-.419.472-.268a1.037,1.037,0,0,1,.472.813",
    transform: "translate(-45.639 -21.17)",
    fill: "#63474b"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78706",
    "data-name": "Path 78706",
    d: "M172.562,74.854a.356.356,0,0,1-.1.276,3.58,3.58,0,0,1-.371.238l-.669-1.148a3.381,3.381,0,0,0,.3-.19.312.312,0,0,1,.367.011,1.039,1.039,0,0,1,.472.813",
    transform: "translate(-43.285 -18.679)",
    fill: "#380009"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78707",
    "data-name": "Path 78707",
    d: "M172.187,75.134c0,.3-.211.419-.472.269a1.042,1.042,0,0,1-.472-.814c0-.3.212-.419.472-.268a1.037,1.037,0,0,1,.472.813",
    transform: "translate(-43.24 -18.75)",
    fill: "#63474b"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78708",
    "data-name": "Path 78708",
    d: "M179.115,91.2l-.193-1.079.386-.223.194,1.079Z",
    transform: "translate(-45.178 -22.7)",
    fill: "#4a3f40"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78709",
    "data-name": "Path 78709",
    d: "M178.657,89.936l-.782-.555.386-.223.782.555Z",
    transform: "translate(-44.914 -22.513)",
    fill: "#5b4548"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78710",
    "data-name": "Path 78710",
    d: "M176.733,89.819l.854-.438.386-.223-.854.438Z",
    transform: "translate(-44.626 -22.513)",
    fill: "#3a2227"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78711",
    "data-name": "Path 78711",
    d: "M178.369,90.011l-.782-.555-.854.438.854,1.143.269.671.706-.618Z",
    transform: "translate(-44.626 -22.588)",
    fill: "#2d191d"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78712",
    "data-name": "Path 78712",
    d: "M178.637,90.722a.255.255,0,0,1-.072.2,2.5,2.5,0,0,1-.268.172l-.483-.829a2.515,2.515,0,0,0,.218-.137.227.227,0,0,1,.265.007.752.752,0,0,1,.34.588",
    transform: "translate(-44.899 -22.748)",
    fill: "#896a6d"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78713",
    "data-name": "Path 78713",
    d: "M178.367,90.924c0,.216-.152.3-.34.194a.751.751,0,0,1-.341-.588c0-.215.152-.3.341-.194a.752.752,0,0,1,.34.588",
    transform: "translate(-44.866 -22.799)",
    fill: "#9e8587"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78714",
    "data-name": "Path 78714",
    d: "M171.513,64.922l.083-.011c.212-.028.367.037.4.165l3.35,13.785a.383.383,0,0,1-.322.469.507.507,0,0,1-.56-.383l-3.33-13.708c-.041-.169.154-.287.378-.317",
    transform: "translate(-43.211 -16.389)",
    fill: "#896a6d"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78715",
    "data-name": "Path 78715",
    d: "M170.331,57.029a.523.523,0,0,0,.173-.392c-.014-.168-5.434-22.848-5.434-22.848l-1.867.534s5.4,22.6,5.41,22.728c.018.164.155.3.4.36a1.519,1.519,0,0,0,1.321-.381",
    transform: "translate(-41.209 -8.532)",
    fill: "#ed8725"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78716",
    "data-name": "Path 78716",
    d: "M164.908,34.143c.3-.315.2-.656-.226-.761a1.518,1.518,0,0,0-1.32.381c-.3.315-.2.656.226.761a1.518,1.518,0,0,0,1.32-.381",
    transform: "translate(-41.206 -8.421)",
    fill: "#f5a355"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78717",
    "data-name": "Path 78717",
    d: "M90.145,53.64a.522.522,0,0,0,.37-.217c.087-.144,8.972-21.7,8.972-21.7l-1.827-.66S88.8,52.543,88.739,52.651a.456.456,0,0,0,.111.525,1.52,1.52,0,0,0,1.294.464",
    transform: "translate(-22.396 -7.843)",
    fill: "#ed8725"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78718",
    "data-name": "Path 78718",
    d: "M102.107,31.907c.43-.078.547-.414.262-.749a1.517,1.517,0,0,0-1.294-.463c-.429.078-.547.413-.262.748a1.52,1.52,0,0,0,1.294.464",
    transform: "translate(-25.417 -7.746)",
    fill: "#f5a355"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78719",
    "data-name": "Path 78719",
    d: "M68.844,34.466,46.545,47.34l-.339-14.4L68.5,20.061l.339.585Z",
    transform: "translate(-11.667 -5.066)",
    fill: "#b74200"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78720",
    "data-name": "Path 78720",
    d: "M56.758,35.51,48.732,40.1V34.791l-.377-.544L56.7,28.923Z",
    transform: "translate(-12.21 -7.303)",
    fill: "#d8661a"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78721",
    "data-name": "Path 78721",
    d: "M68.959,28.483l-22.3,12.874v1.174l22.3-12.875Z",
    transform: "translate(-11.782 -7.192)",
    fill: "#9b7a6d"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78722",
    "data-name": "Path 78722",
    d: "M48.405,35.99V42.1l.339-.215V36.575Z",
    transform: "translate(-12.222 -9.088)",
    fill: "#b74200"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78723",
    "data-name": "Path 78723",
    d: "M36.683,0,65.747,15l.339.585V29.4l-28.5-16.452L37,11.875l-.424-1.461L35.284,3.669,36.09.144Z",
    transform: "translate(-8.909 0)",
    fill: "#ed8725"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78724",
    "data-name": "Path 78724",
    d: "M30.424,0,10.5,11.531l4.7,3.64,22,12.7L59.488,15,37.511,2.308Z",
    transform: "translate(-2.65 0)",
    fill: "#f5a355"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78725",
    "data-name": "Path 78725",
    d: "M47.54,22.986l-8.882,5.073-.036.049.238.148,8.728-5.169Z",
    transform: "translate(-9.752 -5.804)",
    fill: "#ed8725"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78726",
    "data-name": "Path 78726",
    d: "M47.364,22.837l-8.695,5.184.155.1,8.727-5.169Z",
    transform: "translate(-9.764 -5.766)",
    fill: "#ffc55f"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78727",
    "data-name": "Path 78727",
    d: "M46.8,22.548,37.913,27.62l-.036.049.238.148,8.728-5.169Z",
    transform: "translate(-9.564 -5.693)",
    fill: "#ed8725"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78728",
    "data-name": "Path 78728",
    d: "M46.62,22.4l-8.695,5.184.155.1,8.727-5.169Z",
    transform: "translate(-9.576 -5.656)",
    fill: "#ffc55f"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78729",
    "data-name": "Path 78729",
    d: "M46.052,22.109,37.17,27.182l-.036.049.238.148L46.1,22.21Z",
    transform: "translate(-9.376 -5.583)",
    fill: "#ed8725"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78730",
    "data-name": "Path 78730",
    d: "M45.877,21.96l-8.695,5.184.155.1,8.727-5.169Z",
    transform: "translate(-9.389 -5.545)",
    fill: "#ffc55f"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78731",
    "data-name": "Path 78731",
    d: "M45.309,21.671l-8.882,5.073-.036.049.238.149,8.728-5.169Z",
    transform: "translate(-9.189 -5.472)",
    fill: "#ed8725"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78732",
    "data-name": "Path 78732",
    d: "M45.133,21.521l-8.695,5.184.155.1,8.727-5.169Z",
    transform: "translate(-9.201 -5.434)",
    fill: "#ffc55f"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78733",
    "data-name": "Path 78733",
    d: "M44.565,21.232,35.682,26.3l-.036.049.238.148,8.728-5.169Z",
    transform: "translate(-9.001 -5.361)",
    fill: "#ed8725"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78734",
    "data-name": "Path 78734",
    d: "M44.389,21.083l-8.695,5.184.155.1,8.727-5.169Z",
    transform: "translate(-9.013 -5.323)",
    fill: "#ffc55f"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78735",
    "data-name": "Path 78735",
    d: "M43.821,20.794l-8.882,5.073-.036.049.238.148,8.728-5.169Z",
    transform: "translate(-8.813 -5.25)",
    fill: "#ed8725"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78736",
    "data-name": "Path 78736",
    d: "M43.645,20.644l-8.695,5.185.155.1,8.727-5.169Z",
    transform: "translate(-8.825 -5.213)",
    fill: "#ffc55f"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78737",
    "data-name": "Path 78737",
    d: "M60.668,15.178,51.785,20.25l-.036.049.238.148,8.728-5.169Z",
    transform: "translate(-13.067 -3.832)",
    fill: "#ed8725"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78738",
    "data-name": "Path 78738",
    d: "M60.492,15.029,51.8,20.212l.155.1L60.68,15.14Z",
    transform: "translate(-13.079 -3.795)",
    fill: "#ffc55f"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78739",
    "data-name": "Path 78739",
    d: "M59.924,14.739l-8.882,5.073-.036.049.238.148,8.728-5.169Z",
    transform: "translate(-12.879 -3.722)",
    fill: "#ed8725"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78740",
    "data-name": "Path 78740",
    d: "M59.748,14.59l-8.695,5.184.155.1L59.936,14.7Z",
    transform: "translate(-12.891 -3.684)",
    fill: "#ffc55f"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78741",
    "data-name": "Path 78741",
    d: "M59.18,14.3,50.3,19.373l-.036.049.238.148L59.228,14.4Z",
    transform: "translate(-12.691 -3.611)",
    fill: "#ed8725"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78742",
    "data-name": "Path 78742",
    d: "M59,14.152,50.31,19.335l.155.1,8.728-5.169Z",
    transform: "translate(-12.703 -3.573)",
    fill: "#ffc55f"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78743",
    "data-name": "Path 78743",
    d: "M58.437,13.862l-8.882,5.073-.036.049.238.148,8.728-5.169Z",
    transform: "translate(-12.504 -3.5)",
    fill: "#ed8725"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78744",
    "data-name": "Path 78744",
    d: "M58.261,13.713,49.566,18.9l.155.1,8.728-5.169Z",
    transform: "translate(-12.516 -3.463)",
    fill: "#ffc55f"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78745",
    "data-name": "Path 78745",
    d: "M57.693,13.424,48.81,18.5l-.036.049.238.148,8.728-5.169Z",
    transform: "translate(-12.316 -3.39)",
    fill: "#ed8725"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78746",
    "data-name": "Path 78746",
    d: "M57.517,13.275l-8.695,5.184.155.1L57.7,13.386Z",
    transform: "translate(-12.328 -3.352)",
    fill: "#ffc55f"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78747",
    "data-name": "Path 78747",
    d: "M56.949,12.986l-8.882,5.073-.036.049.238.149L57,13.086Z",
    transform: "translate(-12.128 -3.279)",
    fill: "#ed8725"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78748",
    "data-name": "Path 78748",
    d: "M56.773,12.836l-8.695,5.185.155.1,8.728-5.169Z",
    transform: "translate(-12.14 -3.241)",
    fill: "#ffc55f"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78749",
    "data-name": "Path 78749",
    d: "M27.858,19.083l-5.433-2.953-5.988-3.255,0-.452h1.109l10.09,3.767,1.373,1.082v2.444Z",
    transform: "translate(-4.15 -3.137)",
    fill: "#2d191d"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78750",
    "data-name": "Path 78750",
    d: "M44.324,12.8l-11.07,6.391V16.751l11.07-6.391Z",
    transform: "translate(-8.397 -2.616)",
    fill: "#3a2227"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78751",
    "data-name": "Path 78751",
    d: "M40.077,8.722,38.7,7.639,28.614,3.873H27.5l-11.07,6.391h1.109l10.09,3.767,1.373,1.082Z",
    transform: "translate(-4.15 -0.978)",
    fill: "#4a3f40"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78752",
    "data-name": "Path 78752",
    d: "M42.487,8.912,31.417,15.3l1.373,1.082L43.86,9.994Z",
    transform: "translate(-7.933 -2.25)",
    fill: "#5b4548"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78753",
    "data-name": "Path 78753",
    d: "M28.614,3.873l-11.07,6.391H16.435L27.5,3.873Z",
    transform: "translate(-4.15 -0.978)",
    fill: "#362e2f"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78754",
    "data-name": "Path 78754",
    d: "M17.919,10.264,28.233,13.9l1.149.818,10.5-6L38.818,7.79l-9.83-3.917,10.09,3.767,1.374,1.082-11.07,6.391-1.373-1.082Z",
    transform: "translate(-4.525 -0.978)",
    fill: "#6d5358"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78755",
    "data-name": "Path 78755",
    d: "M28.851,19.779H26.442l-1.812-.872-8.813-5.94.463-.294v.265Z",
    transform: "translate(-3.994 -3.2)",
    fill: "#a83c00"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78756",
    "data-name": "Path 78756",
    d: "M31.646,16.013l-.229-.064L36.36,13.1l.229.064Z",
    transform: "translate(-7.933 -3.308)",
    fill: "#231015"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78757",
    "data-name": "Path 78757",
    d: "M38.719,11.941l-.229-.064L43.433,9.03l.229.064Z",
    transform: "translate(-9.719 -2.28)",
    fill: "#231015"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78758",
    "data-name": "Path 78758",
    d: "M30.573,15.615l-.229-.064L35.286,12.7l.229.064Z",
    transform: "translate(-7.662 -3.208)",
    fill: "#231015"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78759",
    "data-name": "Path 78759",
    d: "M37.646,11.542l-.229-.064,4.943-2.848.229.064Z",
    transform: "translate(-9.448 -2.179)",
    fill: "#231015"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78760",
    "data-name": "Path 78760",
    d: "M29.5,15.217l-.229-.064,4.943-2.848.229.064Z",
    transform: "translate(-7.391 -3.107)",
    fill: "#231015"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78761",
    "data-name": "Path 78761",
    d: "M36.572,11.145l-.229-.064,4.943-2.848.229.064Z",
    transform: "translate(-9.177 -2.079)",
    fill: "#231015"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78762",
    "data-name": "Path 78762",
    d: "M28.425,14.819l-.229-.064,4.943-2.848.229.064Z",
    transform: "translate(-7.12 -3.007)",
    fill: "#231015"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78763",
    "data-name": "Path 78763",
    d: "M35.5,10.747l-.229-.064,4.943-2.848.229.064Z",
    transform: "translate(-8.905 -1.978)",
    fill: "#231015"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78764",
    "data-name": "Path 78764",
    d: "M27.351,14.421l-.229-.064,4.943-2.848.229.064Z",
    transform: "translate(-6.848 -2.906)",
    fill: "#231015"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78765",
    "data-name": "Path 78765",
    d: "M34.424,10.349l-.229-.064,4.943-2.847.229.063Z",
    transform: "translate(-8.634 -1.878)",
    fill: "#231015"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78766",
    "data-name": "Path 78766",
    d: "M26.278,14.023l-.229-.064,4.943-2.848.229.064Z",
    transform: "translate(-6.577 -2.806)",
    fill: "#231015"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78767",
    "data-name": "Path 78767",
    d: "M33.351,9.951l-.229-.064L38.064,7.04l.229.064Z",
    transform: "translate(-8.363 -1.778)",
    fill: "#231015"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78768",
    "data-name": "Path 78768",
    d: "M25.2,13.625l-.229-.064,4.943-2.848.229.064Z",
    transform: "translate(-6.306 -2.705)",
    fill: "#231015"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78769",
    "data-name": "Path 78769",
    d: "M32.277,9.553l-.229-.064,4.943-2.848.229.064Z",
    transform: "translate(-8.092 -1.677)",
    fill: "#231015"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78770",
    "data-name": "Path 78770",
    d: "M24.13,13.227l-.229-.064,4.943-2.848.229.064Z",
    transform: "translate(-6.035 -2.605)",
    fill: "#231015"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78771",
    "data-name": "Path 78771",
    d: "M31.2,9.155l-.229-.064,4.943-2.848.229.064Z",
    transform: "translate(-7.821 -1.576)",
    fill: "#231015"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78772",
    "data-name": "Path 78772",
    d: "M23.056,12.829l-.229-.064L27.77,9.918,28,9.981Z",
    transform: "translate(-5.764 -2.504)",
    fill: "#231015"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78773",
    "data-name": "Path 78773",
    d: "M30.13,8.757,29.9,8.693l4.943-2.848.229.064Z",
    transform: "translate(-7.55 -1.476)",
    fill: "#231015"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78774",
    "data-name": "Path 78774",
    d: "M21.983,12.431l-.229-.064L26.7,9.52l.229.064Z",
    transform: "translate(-5.493 -2.404)",
    fill: "#231015"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78775",
    "data-name": "Path 78775",
    d: "M29.056,8.359,28.826,8.3,33.77,5.448,34,5.511Z",
    transform: "translate(-7.279 -1.376)",
    fill: "#231015"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78776",
    "data-name": "Path 78776",
    d: "M20.909,12.033l-.229-.064,4.943-2.848.229.064Z",
    transform: "translate(-5.222 -2.303)",
    fill: "#231015"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78777",
    "data-name": "Path 78777",
    d: "M27.982,7.961,27.753,7.9,32.7,5.05l.229.064Z",
    transform: "translate(-7.008 -1.275)",
    fill: "#231015"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78778",
    "data-name": "Path 78778",
    d: "M19.835,11.636l-.229-.064,4.943-2.847.229.063Z",
    transform: "translate(-4.951 -2.203)",
    fill: "#231015"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78779",
    "data-name": "Path 78779",
    d: "M26.908,7.563,26.679,7.5l4.943-2.848.229.064Z",
    transform: "translate(-6.737 -1.175)",
    fill: "#231015"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78780",
    "data-name": "Path 78780",
    d: "M18.762,11.237l-.229-.064,4.943-2.848.229.064Z",
    transform: "translate(-4.679 -2.102)",
    fill: "#231015"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78781",
    "data-name": "Path 78781",
    d: "M25.835,7.165,25.605,7.1l4.943-2.848.229.064Z",
    transform: "translate(-6.465 -1.074)",
    fill: "#231015"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78782",
    "data-name": "Path 78782",
    d: "M14.635,19.066l-4.7-3.64-.594.144-.806,3.524-.254,7.639.424,1.461L9.3,29.267l5.334,4.2,22.334,12.7V32.35l-.339-.585Z",
    transform: "translate(-2.091 -3.895)",
    fill: "#ce7731"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78783",
    "data-name": "Path 78783",
    d: "M14.693,26.867,8.55,22.108,8.511,23.3l6.182,4.789,22.334,12.9V39.762Z",
    transform: "translate(-2.149 -5.582)",
    fill: "#e5ccb5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_72778",
    "data-name": "Group 72778",
    transform: "translate(7.845 11.531)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_72777",
    "data-name": "Group 72777"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72776",
    "data-name": "Group 72776",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78784",
    "data-name": "Path 78784",
    d: "M10.5,15.426l4.809,3.39,21.885,12.56.99-.584L32.115,27.2l10.44-5.958-.206.959-3.554,8.637-1.606.927-22-12.7Z",
    transform: "translate(-10.495 -15.426)",
    fill: "#ff5f2e"
  }))))), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78785",
    "data-name": "Path 78785",
    d: "M58.729,25.283,52.7,21.8,40.29,28.968l6.029,3.48Z",
    transform: "translate(-10.173 -5.505)",
    fill: "#b84c21"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78786",
    "data-name": "Path 78786",
    d: "M101.44,28.492l-.085-.087a.489.489,0,0,1-.1-.53l3.648-8.811.872.887L102.3,28.324a.528.528,0,0,1-.865.168",
    transform: "translate(-25.557 -4.814)",
    fill: "#896a6d"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78787",
    "data-name": "Path 78787",
    d: "M98.01,22.059l-.606.772a6.367,6.367,0,0,0-1.2,3.237v4.77c0,.911,1.106.993,1.455-.238l.36-.58a4.565,4.565,0,0,0,.905-2.79l.191-4.439c.292-.917-.435-1.609-1.1-.732",
    transform: "translate(-24.291 -5.468)",
    fill: "#1f140b"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78788",
    "data-name": "Path 78788",
    d: "M98.072,22.433l-.31.432a6.367,6.367,0,0,0-1.2,3.237v4.77c0,.911.54.939,1.2.062l.61-.88a4.566,4.566,0,0,0,.905-2.79v-4.77c0-.91-.54-.938-1.2-.061",
    transform: "translate(-24.381 -5.503)",
    fill: "#331818"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78789",
    "data-name": "Path 78789",
    d: "M96.5,21.142v8.639a1.6,1.6,0,0,0,.224.036.59.59,0,0,0,.111-.077.925.925,0,0,0,.085-.128l-.011-8.672a.944.944,0,0,0-1.545-.75l-2.8,2.346.241.561,2.732-2.407a.581.581,0,0,1,.961.453",
    transform: "translate(-23.373 -5.042)",
    fill: "#331818"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78790",
    "data-name": "Path 78790",
    d: "M72.881,6.494l13.941,8.615.848,1.22.339.974-.466.315,1.813,16.721.3,5.524L89.1,43.826l-.255,1.9-.254,1.718L74.28,55.774,68.408,25.038l3.964-18.5Z",
    transform: "translate(-17.273 -1.64)",
    fill: "#380009"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78791",
    "data-name": "Path 78791",
    d: "M68.877,6.542,54.564,14.875l.509-.046L69.5,6.5Z",
    transform: "translate(-13.778 -1.641)",
    fill: "#ffefd2"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78792",
    "data-name": "Path 78792",
    d: "M90.773,40.465l-1.5.865-4.2,2.423-7.275,4.2L75.93,30.278l4.664-2.692,7.136-4.12,1.17-.676Z",
    transform: "translate(-19.173 -5.754)",
    fill: "#67383f"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78793",
    "data-name": "Path 78793",
    d: "M91.405,46.435l-1.522,2.377L88.33,51.236l-.321.5-7.02,4.052-2.554-1.867,7.275-4.2,4.2-2.423Z",
    transform: "translate(-19.805 -11.725)",
    fill: "#67383f"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78794",
    "data-name": "Path 78794",
    d: "M91.637,51.135l-3.575,4.553-7.489,4.36-3.249-.58-1.06,7.578,14.313-8.333Z",
    transform: "translate(-19.257 -12.912)",
    fill: "#b84c21"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78795",
    "data-name": "Path 78795",
    d: "M76.6,65.329l4.276-2.291.637-1.766,6.267-3.719,1.109.539L90.917,57l.806-5.861-3.575,4.553-7.489,4.36-3.249-.579Z",
    transform: "translate(-19.343 -12.912)",
    fill: "#a97f7f"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78796",
    "data-name": "Path 78796",
    d: "M90.8,39.027l-6.933-4-1.991-4.7.224-2.517,7.136-4.119Z",
    transform: "translate(-20.673 -5.983)",
    fill: "#a87b80"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78797",
    "data-name": "Path 78797",
    d: "M69.674,6.5l-14.43,8.331,13.942,8.616L83.5,15.11Z",
    transform: "translate(-13.949 -1.641)",
    fill: "#f2efe2"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78798",
    "data-name": "Path 78798",
    d: "M91.425,44.49l-.02,1.3L91.38,47.3l-1.553,2.423-2.62-1.513-2-1.156-.842-2.767.016-3.834Z",
    transform: "translate(-21.301 -10.215)",
    fill: "#a87b80"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78799",
    "data-name": "Path 78799",
    d: "M53.733,17.643l13.941,8.615.848,1.22.339.974-.466.315,1.813,16.721.3,5.524-.551,3.964-.255,1.9-.254,1.718L49.26,46.936V36.186l3.964-18.5Z",
    transform: "translate(-12.438 -4.455)",
    fill: "#ce7731"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78800",
    "data-name": "Path 78800",
    d: "M68.4,28.766l.466-.315-.339-.974-.848-1.22L53.733,17.643l-.509.046-3.964,18.5,1.359,7.328,2.5,4.113L69.7,56.872l.805-5.86-.3-5.524Z",
    transform: "translate(-12.438 -4.455)",
    fill: "#8c7370"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78801",
    "data-name": "Path 78801",
    d: "M67.938,28.156l2.109,18.158v6.1l-.919,3.361L57.722,49.189l-4.861-7.423L52.041,38.1l1.943-11.443,1.37-5.831Z",
    transform: "translate(-13.14 -5.26)",
    fill: "#380009"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78802",
    "data-name": "Path 78802",
    d: "M71.648,48.191l-6.933-4-1.991-4.694.78-8.8.328-3.707,3.043,1.723L69.83,30.38Z",
    transform: "translate(-15.838 -6.813)",
    fill: "#4f2f32"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78803",
    "data-name": "Path 78803",
    d: "M65.229,51.6l-.016,3.834.842,2.768,5.519,3.185.641-1.938.063-3.815Z",
    transform: "translate(-16.466 -13.03)",
    fill: "#4f2f32"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78804",
    "data-name": "Path 78804",
    d: "M59.562,24.879l-.743,6.274-.725,6.122-2.968,2.062L53.7,37.591l1.886-9.645,1.074-4.741.893.515Z",
    transform: "translate(-13.56 -5.86)",
    fill: "#4f2f32"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78805",
    "data-name": "Path 78805",
    d: "M67.911,36.783l-.814.082a1.9,1.9,0,0,0-1.2,1.9v5.287c0,.91.54,1.538,1.2,1.4l1.114-.2c.666-.138.905-.874.905-1.784V38.183c0-.91-.54-1.538-1.2-1.4",
    transform: "translate(-16.638 -9.283)",
    fill: "#1f140b"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78806",
    "data-name": "Path 78806",
    d: "M67.911,36.981l-.814.082a1.9,1.9,0,0,0-1.2,1.9v5.288c0,.91.54,1.538,1.2,1.4l1.114-.2c.666-.138.905-.874.905-1.784V38.381c0-.91-.54-1.538-1.2-1.4",
    transform: "translate(-16.638 -9.333)",
    fill: "#331818"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78807",
    "data-name": "Path 78807",
    d: "M72.226,30.936l-3.019,2.957a3.887,3.887,0,0,0-1.158,2.778V43.3a.131.131,0,0,0,.038.022.861.861,0,0,0,.155.048.318.318,0,0,0,.311-.068V36.952a3.892,3.892,0,0,1,1.114-2.734l2.786-2.82.032-.344Z",
    transform: "translate(-17.183 -7.811)",
    fill: "#331818"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78808",
    "data-name": "Path 78808",
    d: "M29.63.144,9.7,11.675l.594-.144L30.223,0Z",
    transform: "translate(-2.45 0)",
    fill: "#ed8725"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78809",
    "data-name": "Path 78809",
    d: "M75.082,28.547,89.4,20.214l-.339-.975-.848-1.219L73.9,26.353l.848,1.22Z",
    transform: "translate(-18.659 -4.55)",
    fill: "#d0b6b3"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78810",
    "data-name": "Path 78810",
    d: "M173.084,89.158l-.277-3.33.638-.369.277,3.33Z",
    transform: "translate(-43.635 -21.579)",
    fill: "#3a2227"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78811",
    "data-name": "Path 78811",
    d: "M172.166,85.682l-1.9-.431.638-.368,1.9.431Z",
    transform: "translate(-42.993 -21.433)",
    fill: "#3a2227"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78812",
    "data-name": "Path 78812",
    d: "M167.938,85.971l1.739-.72.638-.369-1.739.72Z",
    transform: "translate(-42.405 -21.433)",
    fill: "#3a2227"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78813",
    "data-name": "Path 78813",
    d: "M171.578,85.807l-1.9-.431-1.739.72.7,3.146,1.313-.536,1.9.431Z",
    transform: "translate(-42.405 -21.558)",
    fill: "#2d191d"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78814",
    "data-name": "Path 78814",
    d: "M156.049,21.787l-3.012,1.739,5.076,7,3.012-1.739Z",
    transform: "translate(-38.643 -5.501)",
    fill: "#dd6617"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78815",
    "data-name": "Path 78815",
    d: "M153.677,21.84l-3.012,1.739,1.773-.053,3.012-1.739Z",
    transform: "translate(-38.044 -5.501)",
    fill: "#f5a355"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78816",
    "data-name": "Path 78816",
    d: "M176.529,92.685l-.193-1.079.386-.223.194,1.079Z",
    transform: "translate(-44.526 -23.075)",
    fill: "#4a3f40"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78817",
    "data-name": "Path 78817",
    d: "M176.072,91.419l-.782-.555.386-.223.782.555Z",
    transform: "translate(-44.262 -22.887)",
    fill: "#3a2227"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78818",
    "data-name": "Path 78818",
    d: "M174.148,91.3l.854-.438.386-.223-.854.438Z",
    transform: "translate(-43.973 -22.887)",
    fill: "#3a2227"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78819",
    "data-name": "Path 78819",
    d: "M175.784,91.495,175,90.94l-.854.438L175,92.521l.269.671.706-.619Z",
    transform: "translate(-43.973 -22.963)",
    fill: "#2d191d"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78820",
    "data-name": "Path 78820",
    d: "M175.441,83.016l-8.467-7.691.36,1.9,6.838,6.236.093,1.362-1.852,2.851.333,1.6,2.864-4.5Z",
    transform: "translate(-42.162 -19.02)",
    fill: "#ea7513"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78821",
    "data-name": "Path 78821",
    d: "M178.47,87.247,178.3,85.49l.638-.368.169,1.757Z",
    transform: "translate(-45.022 -21.494)",
    fill: "#cb5200"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78822",
    "data-name": "Path 78822",
    d: "M177.56,87.841l-2.864,4.5.638-.368,2.864-4.5Z",
    transform: "translate(-44.111 -22.087)",
    fill: "#b84c21"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78823",
    "data-name": "Path 78823",
    d: "M175.441,82.892,166.974,75.2l.638-.369,8.467,7.691Z",
    transform: "translate(-42.162 -18.896)",
    fill: "#f5a355"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78824",
    "data-name": "Path 78824",
    d: "M177.792,86.9a.356.356,0,0,1-.1.276,3.584,3.584,0,0,1-.371.238l-.669-1.148a3.377,3.377,0,0,0,.3-.19.312.312,0,0,1,.367.011,1.039,1.039,0,0,1,.472.813",
    transform: "translate(-44.605 -21.722)",
    fill: "#380009"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78825",
    "data-name": "Path 78825",
    d: "M177.417,87.184c0,.3-.211.419-.472.269a1.042,1.042,0,0,1-.472-.814c0-.3.212-.419.472-.268a1.037,1.037,0,0,1,.472.813",
    transform: "translate(-44.56 -21.793)",
    fill: "#63474b"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78826",
    "data-name": "Path 78826",
    d: "M168.291,77.32a.356.356,0,0,1-.1.276,3.584,3.584,0,0,1-.371.238l-.669-1.148a3.508,3.508,0,0,0,.3-.189.311.311,0,0,1,.367.01,1.039,1.039,0,0,1,.472.813",
    transform: "translate(-42.206 -19.302)",
    fill: "#380009"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78827",
    "data-name": "Path 78827",
    d: "M167.916,77.6c0,.3-.211.419-.472.269a1.041,1.041,0,0,1-.472-.814c0-.3.212-.419.472-.268a1.037,1.037,0,0,1,.472.813",
    transform: "translate(-42.161 -19.372)",
    fill: "#63474b"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78828",
    "data-name": "Path 78828",
    d: "M175.5,93.282,175.3,92.2l.386-.223.194,1.079Z",
    transform: "translate(-44.265 -23.225)",
    fill: "#4a3f40"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78829",
    "data-name": "Path 78829",
    d: "M175.039,92.016l-.782-.555.386-.223.782.555Z",
    transform: "translate(-44.001 -23.038)",
    fill: "#5b4548"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78830",
    "data-name": "Path 78830",
    d: "M173.114,91.9l.854-.438.386-.223-.854.438Z",
    transform: "translate(-43.712 -23.038)",
    fill: "#3a2227"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78831",
    "data-name": "Path 78831",
    d: "M174.75,92.091l-.782-.555-.854.438.854,1.143.269.671.706-.619Z",
    transform: "translate(-43.712 -23.113)",
    fill: "#2d191d"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78832",
    "data-name": "Path 78832",
    d: "M58.579,15.581l14.1,8.315.054.08-.4.243L58.492,15.746Z",
    transform: "translate(-14.77 -3.934)",
    fill: "#e5d6be"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78833",
    "data-name": "Path 78833",
    d: "M58.924,15.336l13.784,8.5-.262.158L58.608,15.519Z",
    transform: "translate(-14.799 -3.872)",
    fill: "#ffefd2"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78834",
    "data-name": "Path 78834",
    d: "M61.707,13.784l14.1,8.315.055.08-.4.244L61.621,13.949Z",
    transform: "translate(-15.56 -3.48)",
    fill: "#e5d6be"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78835",
    "data-name": "Path 78835",
    d: "M62.052,13.539l13.784,8.5-.261.158L61.736,13.722Z",
    transform: "translate(-15.589 -3.419)",
    fill: "#ffefd2"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78836",
    "data-name": "Path 78836",
    d: "M64.836,11.987l14.1,8.315.054.08-.4.243L64.75,12.152Z",
    transform: "translate(-16.35 -3.027)",
    fill: "#e5d6be"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78837",
    "data-name": "Path 78837",
    d: "M65.181,11.742l13.784,8.5L78.7,20.4,64.864,11.925Z",
    transform: "translate(-16.379 -2.965)",
    fill: "#ffefd2"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78838",
    "data-name": "Path 78838",
    d: "M67.964,10.19l14.1,8.315.054.08-.4.243L67.878,10.355Z",
    transform: "translate(-17.139 -2.573)",
    fill: "#e5d6be"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78839",
    "data-name": "Path 78839",
    d: "M68.309,9.945l13.784,8.5-.261.158L67.993,10.128Z",
    transform: "translate(-17.168 -2.511)",
    fill: "#ffefd2"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78840",
    "data-name": "Path 78840",
    d: "M71.092,8.393l14.1,8.315.054.08-.4.243L71.006,8.558Z",
    transform: "translate(-17.929 -2.119)",
    fill: "#e5d6be"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78841",
    "data-name": "Path 78841",
    d: "M71.437,8.148l13.784,8.5-.261.158L71.121,8.331Z",
    transform: "translate(-17.958 -2.057)",
    fill: "#ffefd2"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78842",
    "data-name": "Path 78842",
    d: "M80.5,65.788l-2.05,1.2.132-1.534,2.545-1.137Z",
    transform: "translate(-19.808 -16.241)",
    fill: "#f1f1f1"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78843",
    "data-name": "Path 78843",
    d: "M80.541,65.688l-.731-.378-1.188.045.161-1.434,2.385.3Z",
    transform: "translate(-19.852 -16.14)",
    fill: "#dff1f1"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78844",
    "data-name": "Path 78844",
    d: "M81.12,64.319l-.626,1.47-2.05,1.2-.007.156,2.187-1.28.634-1.428Z",
    transform: "translate(-19.805 -16.241)",
    fill: "#423d3d"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78845",
    "data-name": "Path 78845",
    d: "M79.27,66.262l-.647.379.02-.422.647-.38Z",
    transform: "translate(-19.853 -16.625)",
    fill: "#fff"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78846",
    "data-name": "Path 78846",
    d: "M78.443,67.486l-.007.156,2.187-1.28-.129-.076Z",
    transform: "translate(-19.805 -16.737)",
    fill: "#716d6d"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78847",
    "data-name": "Path 78847",
    d: "M94.2,56.671l-1.535.872-.681-.484,2.689-3.463Z",
    transform: "translate(-23.227 -13.533)",
    fill: "#f1f1f1"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78848",
    "data-name": "Path 78848",
    d: "M94.2,56.671l-.6-.724L92.231,57l.435.546-.681-.484,2.689-3.463-.024,1.735Z",
    transform: "translate(-23.227 -13.533)",
    fill: "#dff1f1"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78849",
    "data-name": "Path 78849",
    d: "M94.9,53.568,94.757,55.2l-.326,1.443-1.535.872.25.011,1.414-.807.321-1.417.161-1.815Z",
    transform: "translate(-23.457 -13.506)",
    fill: "#423d3d"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78850",
    "data-name": "Path 78850",
    d: "M93.3,57.542l-.647.379.02-.422.647-.38Z",
    transform: "translate(-23.396 -14.423)",
    fill: "#fff"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78851",
    "data-name": "Path 78851",
    d: "M92.9,58.582l.249.011,1.415-.807-.129-.076Z",
    transform: "translate(-23.457 -14.572)",
    fill: "#716d6d"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78852",
    "data-name": "Path 78852",
    d: "M166.865,68.513l-1.378-1.178-2.712-10.556,1.378,1.178Z",
    transform: "translate(-41.102 -14.337)",
    fill: "#a3a8b1"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78853",
    "data-name": "Path 78853",
    d: "M164.643,59.864l-1.378-1.178-.213-.827,1.378,1.178Z",
    transform: "translate(-41.171 -14.61)",
    fill: "#c12f1b"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78854",
    "data-name": "Path 78854",
    d: "M165.256,62.251l-1.378-1.178-.213-.827,1.378,1.178Z",
    transform: "translate(-41.326 -15.212)",
    fill: "#c12f1b"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78855",
    "data-name": "Path 78855",
    d: "M165.869,64.637l-1.378-1.178-.213-.827,1.378,1.178Z",
    transform: "translate(-41.481 -15.815)",
    fill: "#c12f1b"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78856",
    "data-name": "Path 78856",
    d: "M166.482,67.024,165.1,65.846l-.213-.827L166.27,66.2Z",
    transform: "translate(-41.636 -16.417)",
    fill: "#c12f1b"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78857",
    "data-name": "Path 78857",
    d: "M167.1,69.41l-1.378-1.178L165.5,67.4l1.378,1.178Z",
    transform: "translate(-41.791 -17.02)",
    fill: "#c12f1b"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78858",
    "data-name": "Path 78858",
    d: "M167.709,71.8l-1.378-1.178-.213-.827L167.5,70.97Z",
    transform: "translate(-41.946 -17.623)",
    fill: "#c12f1b"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78859",
    "data-name": "Path 78859",
    d: "M163.238,54.394l-1.378-1.178L159.148,42.66l1.378,1.178Z",
    transform: "translate(-40.186 -10.772)",
    fill: "#a3a8b1"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78860",
    "data-name": "Path 78860",
    d: "M161.016,45.745l-1.378-1.178-.213-.827,1.378,1.178Z",
    transform: "translate(-40.255 -11.044)",
    fill: "#c12f1b"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78861",
    "data-name": "Path 78861",
    d: "M161.629,48.132l-1.378-1.178-.213-.827,1.378,1.178Z",
    transform: "translate(-40.41 -11.647)",
    fill: "#c12f1b"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78862",
    "data-name": "Path 78862",
    d: "M162.242,50.518l-1.378-1.178-.213-.827,1.378,1.178Z",
    transform: "translate(-40.565 -12.25)",
    fill: "#c12f1b"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78863",
    "data-name": "Path 78863",
    d: "M162.855,52.9l-1.378-1.178-.213-.827,1.378,1.178Z",
    transform: "translate(-40.72 -12.852)",
    fill: "#c12f1b"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78864",
    "data-name": "Path 78864",
    d: "M163.468,55.292l-1.378-1.178-.213-.827,1.378,1.178Z",
    transform: "translate(-40.875 -13.455)",
    fill: "#c12f1b"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78865",
    "data-name": "Path 78865",
    d: "M164.081,57.678,162.7,56.5l-.213-.827,1.378,1.178Z",
    transform: "translate(-41.03 -14.058)",
    fill: "#c12f1b"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78866",
    "data-name": "Path 78866",
    d: "M122.285,30.6l1.708-.607,10.5,2.914-1.709.607Z",
    transform: "translate(-30.877 -7.572)",
    fill: "#e2d9bc"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78867",
    "data-name": "Path 78867",
    d: "M134.159,33.89l1.708-.607.824.229-1.709.607Z",
    transform: "translate(-33.876 -8.404)",
    fill: "#c12f1b"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78868",
    "data-name": "Path 78868",
    d: "M131.785,33.232l1.709-.607.823.229-1.709.606Z",
    transform: "translate(-33.276 -8.238)",
    fill: "#c12f1b"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78869",
    "data-name": "Path 78869",
    d: "M129.41,32.573l1.709-.607.823.229-1.709.606Z",
    transform: "translate(-32.677 -8.072)",
    fill: "#c12f1b"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78870",
    "data-name": "Path 78870",
    d: "M127.036,31.914l1.708-.607.824.229-1.709.606Z",
    transform: "translate(-32.077 -7.905)",
    fill: "#c12f1b"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78871",
    "data-name": "Path 78871",
    d: "M124.661,31.255l1.709-.607.823.229-1.709.607Z",
    transform: "translate(-31.478 -7.739)",
    fill: "#c12f1b"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78872",
    "data-name": "Path 78872",
    d: "M122.287,30.6,124,29.989l.824.229-1.709.607Z",
    transform: "translate(-30.878 -7.572)",
    fill: "#c12f1b"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78873",
    "data-name": "Path 78873",
    d: "M174.935,92.8a.257.257,0,0,1-.073.2,2.49,2.49,0,0,1-.268.172l-.485-.833s.171-.1.219-.137a.225.225,0,0,1,.265.007.753.753,0,0,1,.342.59",
    transform: "translate(-43.963 -23.272)",
    fill: "#896a6d"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78874",
    "data-name": "Path 78874",
    d: "M174.664,93c0,.217-.153.3-.342.2a.753.753,0,0,1-.342-.59c0-.217.153-.3.342-.2a.754.754,0,0,1,.342.59",
    transform: "translate(-43.931 -23.323)",
    fill: "#9e8587"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78875",
    "data-name": "Path 78875",
    d: "M171.6,87.557a.507.507,0,0,1-.142.391,5.1,5.1,0,0,1-.525.336l-.948-1.626a4.845,4.845,0,0,0,.427-.269.444.444,0,0,1,.52.016,1.472,1.472,0,0,1,.668,1.152",
    transform: "translate(-42.922 -21.794)",
    fill: "#896a6d"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78876",
    "data-name": "Path 78876",
    d: "M171.072,87.953c0,.423-.3.594-.668.38a1.469,1.469,0,0,1-.668-1.152c0-.423.3-.594.668-.38a1.472,1.472,0,0,1,.668,1.152",
    transform: "translate(-42.859 -21.894)",
    fill: "#9e8587"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78877",
    "data-name": "Path 78877",
    d: "M107.663,19.214a.356.356,0,0,1-.1.276c-.087.076-1.018.65-1.018.65l-.67-1.148s.884-.546.949-.6a.312.312,0,0,1,.367.011,1.039,1.039,0,0,1,.472.813",
    transform: "translate(-26.734 -4.63)",
    fill: "#380009"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78878",
    "data-name": "Path 78878",
    d: "M106.641,20.044c0,.3-.211.419-.472.269a1.041,1.041,0,0,1-.472-.814c0-.3.212-.419.472-.268a1.037,1.037,0,0,1,.472.813",
    transform: "translate(-26.689 -4.84)",
    fill: "#63474b"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78879",
    "data-name": "Path 78879",
    d: "M151.551,25.663a.356.356,0,0,1-.1.276c-.087.076-1.018.65-1.018.65l-.67-1.148s.884-.546.949-.6a.312.312,0,0,1,.367.011,1.039,1.039,0,0,1,.472.813",
    transform: "translate(-37.816 -6.258)",
    fill: "#380009"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78880",
    "data-name": "Path 78880",
    d: "M150.529,26.494c0,.3-.211.419-.472.269a1.042,1.042,0,0,1-.472-.814c0-.3.212-.419.472-.268a1.037,1.037,0,0,1,.472.813",
    transform: "translate(-37.771 -6.468)",
    fill: "#63474b"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78881",
    "data-name": "Path 78881",
    d: "M58.17,23.9l2.006,1.158-.743,6.274-3.3,1.942Z",
    transform: "translate(-14.174 -6.034)",
    fill: "#664a4c"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78882",
    "data-name": "Path 78882",
    d: "M67.139,28.706l-3.37,1.984.328-3.707Z",
    transform: "translate(-16.102 -6.813)",
    fill: "#664a4c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_72781",
    "data-name": "Group 72781",
    transform: "translate(6.192 11.531)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_72780",
    "data-name": "Group 72780",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72779",
    "data-name": "Group 72779",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78883",
    "data-name": "Path 78883",
    d: "M14.635,19.066v14.4L9.3,29.267l-.594-1.073-.424-1.461.254-7.639.806-3.524.594-.144Z",
    transform: "translate(-8.283 -15.426)",
    fill: "#dfd4cd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72784",
    "data-name": "Group 72784",
    transform: "translate(21.428 7.346)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_72783",
    "data-name": "Group 72783",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72782",
    "data-name": "Group 72782",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78884",
    "data-name": "Path 78884",
    d: "M28.959,37.192h-.294V22.783L50.974,9.829l.147.253L28.959,22.952Z",
    transform: "translate(-28.666 -9.828)",
    fill: "#e7ce68"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72787",
    "data-name": "Group 72787",
    transform: "translate(12.397 25.334)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_72786",
    "data-name": "Group 72786",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72785",
    "data-name": "Group 72785",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78885",
    "data-name": "Path 78885",
    d: "M25.685,39.4l-8.808-5v3.736h-.293V33.892l9.246,5.253Z",
    transform: "translate(-16.585 -33.892)",
    fill: "#e7ce68"
  }))))), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78886",
    "data-name": "Path 78886",
    d: "M50.522,37.981l-.472-.268a1.509,1.509,0,0,1-.733-1.644L51.784,24.8a2.073,2.073,0,0,1,1.088-1.408l.067-.033.567.016-.016.587-.414-.011a1.485,1.485,0,0,0-.717.975L49.89,36.195a.925.925,0,0,0,.449,1.007l.472.268Z",
    transform: "translate(-12.444 -5.898)",
    fill: "#380009"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78887",
    "data-name": "Path 78887",
    d: "M43.157,49.047a1.073,1.073,0,0,1-.592-.176,1.108,1.108,0,0,1-.5-.928V40.79a2.169,2.169,0,0,1,1.028-1.852l.31-.194.312.5-.311.194a1.586,1.586,0,0,0-.751,1.354v7.153a.52.52,0,0,0,.73.477l.176.244.118.27a1.307,1.307,0,0,1-.518.114",
    transform: "translate(-10.621 -9.783)",
    fill: "#380009"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78888",
    "data-name": "Path 78888",
    d: "M160.986,31.189c-.031-.058-3.2-5.746-4.126-6.97a4.431,4.431,0,0,0-2.707-1.781,2.664,2.664,0,0,0-2.031.727l-.384-.444a3.19,3.19,0,0,1,2.476-.866,5.018,5.018,0,0,1,3.114,2.01c.952,1.258,4.04,6.8,4.171,7.039Z",
    transform: "translate(-38.314 -5.514)",
    fill: "#380009"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78889",
    "data-name": "Path 78889",
    d: "M153.468,38.457a.675.675,0,0,1-.191.522,6.656,6.656,0,0,1-.7.451l-1.269-2.176a6.537,6.537,0,0,0,.572-.36.592.592,0,0,1,.7.02,1.97,1.97,0,0,1,.894,1.542",
    transform: "translate(-38.206 -9.29)",
    fill: "#380009"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78890",
    "data-name": "Path 78890",
    d: "M152.758,38.987c0,.567-.4.795-.893.51a1.97,1.97,0,0,1-.894-1.542c0-.566.4-.795.894-.51a1.971,1.971,0,0,1,.893,1.542",
    transform: "translate(-38.121 -9.424)",
    fill: "#63474b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_72790",
    "data-name": "Group 72790",
    transform: "translate(36.822 41.931)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_72789",
    "data-name": "Group 72789"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72788",
    "data-name": "Group 72788",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78891",
    "data-name": "Path 78891",
    d: "M83.825,59.484l-.067.481L69.445,68.3,49.26,56.645v-.551L69.533,67.707Z",
    transform: "translate(-49.26 -56.095)",
    fill: "#bfa89a"
  }))))), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78892",
    "data-name": "Path 78892",
    d: "M55.244,14.828,69.5,23.261l.91.808L83.7,16.249,83.18,15.3,69.675,6.5,83.5,15.11l.848,1.22L70.033,24.663l-.848-1.22Z",
    transform: "translate(-13.949 -1.641)",
    fill: "#e2cfc7"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78893",
    "data-name": "Path 78893",
    d: "M79.785,27.862l.392-1.158,6.881-3.968.557.568Z",
    transform: "translate(-20.146 -5.741)",
    fill: "#331818"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78894",
    "data-name": "Path 78894",
    d: "M81.367,27.54l-.814.469v.39l.946-.787Z",
    transform: "translate(-20.34 -6.954)",
    fill: "#dc6e36"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78895",
    "data-name": "Path 78895",
    d: "M81.543,27.637l-.814.469V28.5l.814-.48Z",
    transform: "translate(-20.384 -6.979)",
    fill: "#ff8936"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78896",
    "data-name": "Path 78896",
    d: "M80.685,28.241l-.132-.073v.39l.132.073Z",
    transform: "translate(-20.34 -7.113)",
    fill: "#d75716"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78897",
    "data-name": "Path 78897",
    d: "M85.068,25.411l-.814.469v.39l.946-.787Z",
    transform: "translate(-21.274 -6.416)",
    fill: "#dc6e36"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78898",
    "data-name": "Path 78898",
    d: "M85.244,25.508l-.814.469v.39l.814-.479Z",
    transform: "translate(-21.319 -6.441)",
    fill: "#ff8936"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78899",
    "data-name": "Path 78899",
    d: "M84.386,26.112l-.132-.073v.39l.132.073Z",
    transform: "translate(-21.275 -6.575)",
    fill: "#d75716"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78900",
    "data-name": "Path 78900",
    d: "M88.769,23.282l-.814.469v.391l.946-.788Z",
    transform: "translate(-22.209 -5.879)",
    fill: "#dc6e36"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78901",
    "data-name": "Path 78901",
    d: "M88.945,23.379l-.814.469v.391l.814-.48Z",
    transform: "translate(-22.253 -5.903)",
    fill: "#ff8936"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78902",
    "data-name": "Path 78902",
    d: "M88.087,23.983l-.132-.072v.39l.132.073Z",
    transform: "translate(-22.209 -6.037)",
    fill: "#d75716"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78903",
    "data-name": "Path 78903",
    d: "M37.82,48.64a.609.609,0,0,1-.3-.09,1.337,1.337,0,0,1-.615-1.061c0-.3.16-.5.408-.5a.6.6,0,0,1,.3.091,1.338,1.338,0,0,1,.615,1.061c0,.3-.16.5-.408.5",
    transform: "translate(-9.318 -11.865)",
    fill: "#ddd"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78904",
    "data-name": "Path 78904",
    d: "M38.084,48.241c0,.36-.254.5-.567.324a1.252,1.252,0,0,1-.567-.979c0-.36.254-.5.567-.323a1.25,1.25,0,0,1,.567.978",
    transform: "translate(-9.33 -11.914)",
    fill: "#ff9e38"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78905",
    "data-name": "Path 78905",
    d: "M19.165,37.872a.609.609,0,0,1-.3-.09,1.337,1.337,0,0,1-.615-1.061c0-.3.16-.5.407-.5a.6.6,0,0,1,.3.091,1.338,1.338,0,0,1,.615,1.061c0,.3-.161.5-.408.5",
    transform: "translate(-4.608 -9.146)",
    fill: "#ddd"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78906",
    "data-name": "Path 78906",
    d: "M19.428,37.473c0,.36-.254.5-.568.324a1.252,1.252,0,0,1-.567-.979c0-.36.254-.5.567-.323a1.249,1.249,0,0,1,.568.978",
    transform: "translate(-4.619 -9.195)",
    fill: "#ff9e38"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78907",
    "data-name": "Path 78907",
    d: "M34.584,37.8l.01-.326L24.153,31.447l-.009.326Z",
    transform: "translate(-6.096 -7.941)",
    fill: "#380009"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78908",
    "data-name": "Path 78908",
    d: "M34.584,36.764l.01-.326L24.153,30.41l-.009.326Z",
    transform: "translate(-6.096 -7.679)",
    fill: "#380009"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78909",
    "data-name": "Path 78909",
    d: "M34.584,35.727l.01-.326L24.153,29.373l-.009.326Z",
    transform: "translate(-6.096 -7.417)",
    fill: "#380009"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78910",
    "data-name": "Path 78910",
    d: "M34.584,34.69l.01-.326L24.153,28.336l-.009.326Z",
    transform: "translate(-6.096 -7.155)",
    fill: "#380009"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78911",
    "data-name": "Path 78911",
    d: "M34.584,33.653l.01-.326L24.153,27.3l-.009.326Z",
    transform: "translate(-6.096 -6.893)",
    fill: "#380009"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78912",
    "data-name": "Path 78912",
    d: "M12.657,31.85v.907l-.833-.71V30.861a.466.466,0,0,1,.17-.372.389.389,0,0,1,.5.19.907.907,0,0,1,.086.145,3.553,3.553,0,0,1,.074,1.026",
    transform: "translate(-2.986 -7.688)",
    fill: "#902e00"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78913",
    "data-name": "Path 78913",
    d: "M12.5,30.678l-.256,1.16-.418.208V30.861a.463.463,0,0,1,.17-.372.39.39,0,0,1,.5.19",
    transform: "translate(-2.986 -7.688)",
    fill: "#983800"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78914",
    "data-name": "Path 78914",
    d: "M11.825,32.516l.418-.207.417.318,0,.6Z",
    transform: "translate(-2.986 -8.158)",
    fill: "#ed8725"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78915",
    "data-name": "Path 78915",
    d: "M151.972,33.69l-1.655-.147-.646-.49-5.3-2.012-1.186-1.628-2.138-.844,2.138-1.332,2.426.715,2.243.395-3.012,1.739.357.476,5.3,2.012Z",
    transform: "translate(-35.615 -6.877)",
    fill: "#a83c00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_72793",
    "data-name": "Group 72793",
    transform: "translate(58.683 12.929)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_72792",
    "data-name": "Group 72792",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72791",
    "data-name": "Group 72791",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78916",
    "data-name": "Path 78916",
    d: "M83.245,18.749,83.108,17.3l-3.541.069v.007a1.862,1.862,0,0,0-.752.17c-.436.224-.406.576.067.786a1.885,1.885,0,0,0,.6.132h0Z",
    transform: "translate(-78.507 -17.297)",
    fill: "#d8d8d8"
  }))))), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78917",
    "data-name": "Path 78917",
    d: "M83.037,17.066l2.7-.04v.989h0c.013.165-.105.331-.357.461a2.5,2.5,0,0,1-1.911.031c-.276-.122-.422-.286-.434-.452Z",
    transform: "translate(-20.967 -4.299)",
    fill: "#67383f"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78918",
    "data-name": "Path 78918",
    d: "M83.161,13.78l2.328-.026.25,2.446c.013.164-.105.331-.357.461a2.507,2.507,0,0,1-1.911.031c-.276-.123-.422-.286-.434-.452Z",
    transform: "translate(-20.967 -3.473)",
    fill: "#d76600"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78919",
    "data-name": "Path 78919",
    d: "M83.512,13.2a2.157,2.157,0,0,1,1.645-.026c.472.209.5.561.067.786a2.157,2.157,0,0,1-1.645.026c-.473-.21-.5-.562-.067-.786",
    transform: "translate(-21.009 -3.289)",
    fill: "#ffa71e"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78920",
    "data-name": "Path 78920",
    d: "M83.485,16.395a2.32,2.32,0,0,1,1.772-.028c.51.226.541.605.072.847a2.323,2.323,0,0,1-1.774.028c-.509-.226-.541-.605-.07-.847",
    transform: "translate(-20.996 -4.092)",
    fill: "#ff9c00"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78921",
    "data-name": "Path 78921",
    d: "M85.023,15.179a1.837,1.837,0,0,1,.044,1.155c-.128.3-.692.218-.814-.109a.9.9,0,0,1,.042-.8c.129-.3.607-.573.728-.246",
    transform: "translate(-21.255 -3.795)",
    fill: "#ff9c00"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78922",
    "data-name": "Path 78922",
    d: "M84.541,15.5a1.774,1.774,0,0,1-.011,1.048c-.108.244-.277.171-.379-.163a1.78,1.78,0,0,1,.012-1.048c.108-.244.277-.171.378.163",
    transform: "translate(-21.23 -3.836)",
    fill: "#ffa71e"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialMovements);
export default __webpack_public_path__ + "static/media/materialMovements.23843c7b8222cfc6303039121e3f23cf.svg";
export { ForwardRef as ReactComponent };